import { report360 } from '@/locales/ar/report360';
export const assets = {
list: {
zonesAction: "\u0627\u0644\u0645\u0646\u0627\u0637\u0642",
zonesTitle_zero: "\u0645\u0646\u0627\u0637\u0642 \u0627\u0644\u0623\u0635\u0648\u0644",
zonesTitle_one: "\u0645\u0646\u0627\u0637\u0642 \u0623\u0635\u0644 \u0648\u0627\u062d\u062f",
zonesTitle_two: "\u0645\u0646\u0627\u0637\u0642 \u0623\u0635\u0644\u064a\u0646",
zonesTitle_few: "\u0645\u0646\u0627\u0637\u0642 {{count}} \u0623\u0635\u0648\u0644",
zonesTitle_many: "\u0645\u0646\u0627\u0637\u0642 {{count}} \u0623\u0635\u0644\u064b\u0627",
zonesTitle_other: "\u0645\u0646\u0627\u0637\u0642 {{count}} \u0623\u0635\u0644",
zonesAdd: "\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0646\u0627\u0637\u0642",
zonesRemove: "\u0625\u0632\u0627\u0644\u0629",
zonesSaved_zero: "\u0644\u0645 \u062a\u064f\u062d\u0641\u0638 \u0645\u0646\u0627\u0637\u0642",
zonesSaved_one: "\u062d\u064f\u0641\u0638\u062a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0639\u0644\u0649 \u0623\u0635\u0644 \u0648\u0627\u062d\u062f",
zonesSaved_two: "\u062d\u064f\u0641\u0638\u062a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0639\u0644\u0649 \u0623\u0635\u0644\u064a\u0646",
zonesSaved_few: "\u062d\u064f\u0641\u0638\u062a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0639\u0644\u0649 {{count}} \u0623\u0635\u0648\u0644",
zonesSaved_many: "\u062d\u064f\u0641\u0638\u062a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0639\u0644\u0649 {{count}} \u0623\u0635\u0644\u064b\u0627",
zonesSaved_other: "\u062d\u064f\u0641\u0638\u062a \u0627\u0644\u0645\u0646\u0627\u0637\u0642 \u0639\u0644\u0649 {{count}} \u0623\u0635\u0644",
zonesFailedTitle: "\u062a\u0639\u0630\u0651\u0631 \u062d\u0641\u0638 \u0627\u0644\u0645\u0646\u0627\u0637\u0642",
zonesFailedBody: "\u0631\u0628\u0645\u0627 \u0644\u0645 \u062a\u062a\u063a\u064a\u0631 \u0628\u0639\u0636 \u0627\u0644\u0623\u0635\u0648\u0644. \u062a\u062d\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0627\u062a\u0635\u0627\u0644 \u0648\u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
  showMeHow: "أرني كيف",
title: "الأصول",
viewList: "عرض القائمة",
viewCards: "عرض البطاقات",
viewGraph: "عرض الشبكة — خريطة حرارية حسب الحالة",
viewMap: "عرض الخريطة",
viewLabel: "العرض",
subtitleOwned_one: "أصل واحد",
subtitleOwned_other: "{{count}} أصل",
subtitleOwnedOfLimit_zero: "{{owned}} من {{count}} أصل",
subtitleOwnedOfLimit_one: "{{owned}} من أصل واحد",
subtitleOwnedOfLimit_two: "{{owned}} من أصلين",
subtitleOwnedOfLimit_few: "{{owned}} من {{count}} أصول",
subtitleOwnedOfLimit_many: "{{owned}} من {{count}} أصلًا",
subtitleOwnedOfLimit_other: "{{owned}} من {{count}} أصل",
subtitleSharedEmpty: "التقارير المُشاركة معك تظهر هنا",
subtitleShared_one: "أصل واحد مُشارك معك",
subtitleShared_other: "{{count}} أصل مُشارك معك",
shareWithContactSubtitle: "مشاركة أصل مع {{name}}",
shareWithContactSubtitleNoName: "مشاركة أصل مع جهة الاتصال هذه",
searchPlaceholder: "بحث",
searchA11y: "البحث في الأصول",
refine: "تصفية",
refineA11y: "تصفية قائمة الأصول",
tools: "أدوات",
addAsset: "إضافة أصل",
trySample: "جرّب نموذجًا",
trySampleError: "تعذر إعداد النموذج. أضف أصلًا يدويًا.",
addAssetA11y: "إضافة أصل جديد",
refineSheetTitle: "تصفية الأصول",
scope: "النطاق",
groupBy: "تجميع حسب",
filters: "عوامل التصفية",
pickerType: "نوع الأصل",
pickerSort: "الترتيب حسب",
pickerHealth: "درجة الصحة",
pickerRelationship: "نوع العلاقة",
toolsMenuTitle: "أدوات",
selectAssets: "تحديد الأصول",
scanQr: "مسح رمز QR",
exportAllCsv: "تصدير الكل (CSV)",
exportAllA11y: "تنزيل جميع الأصول الظاهرة كملف CSV",
emptyNoAssetsTitle: "لا توجد أصول بعد",
emptyNoAssetsSub: "أضف أصلك الأول لتبدأ عليه الفحوصات والأعمال.",
emptyContractorSub: "تظهر هنا الأصول التي يشاركها عملاؤك معك؛ أما الأعمال المسندة إليك فتجدها تحت «العمل». يمكنك أيضًا تسجيل أصولك الخاصة.",
emptySharedNoneTitle: "لا توجد أصول مُشاركة بعد",
emptySharedNoneSub: "ستظهر هنا الأصول من التفتيشات المُشاركة معك. افتح تقريرًا مُشاركًا من النشاط أو رابط البريد.",
emptyScopeTitle: "لا توجد أصول في {{scope}}",
emptyScopeSub: "غيّر مرشح النطاق أو أضف أصولًا إلى هذا الفريق.",
emptyFilterTitle: "لا توجد أصول مطابقة",
emptyFilterSub: "جرّب كلمات بحث أخرى أو امسح عوامل التصفية.",
clearFilters: "مسح عوامل التصفية",
webViewerEmptyTitle: "لم يُحدد صف",
webViewerEmptySub: "حدد أصلًا في القائمة لفتح العارض أدناه.",
workspaceInsightSummary: "{{total}} في العرض · {{poor}} صحة ضعيفة · {{watch}} مراقبة · {{good}} جيدة · {{unscored}} بلا تقييم",
operationalInsight: {
insightPanelTitle: "رؤى السجل",
insightSourceExisting: "فئات حالة الأصول الحالية",
summaryLine: "{{total}} أصل · {{poor}} حالة ضعيفة · {{watch}} تحت المراقبة · {{good}} جيدة · {{unscored}} بدون تقييم",
poorExplanation_zero: "يحصل {{count}} أصل على 40 أو أقل في تقييم الحالة.",
poorExplanation_one: "يحصل أصل واحد على 40 أو أقل في تقييم الحالة.",
poorExplanation_two: "يحصل أصلان على 40 أو أقل في تقييم الحالة.",
poorExplanation_few: "يحصل {{count}} أصول على 40 أو أقل في تقييم الحالة.",
poorExplanation_many: "يحصل {{count}} أصلًا على 40 أو أقل في تقييم الحالة.",
poorExplanation_other: "يحصل {{count}} أصل على 40 أو أقل في تقييم الحالة.",
poorRecommended: "أعط الأولوية للتفتيشات وأوامر العمل والمستندات التي تخفض هذه التقييمات.",
poorCta: "تصفية الحالة الضعيفة",
watchExplanation_zero: "يقع {{count}} أصل في فئة المراقبة (41–70).",
watchExplanation_one: "يقع أصل واحد في فئة المراقبة (41–70).",
watchExplanation_two: "يقع أصلان في فئة المراقبة (41–70).",
watchExplanation_few: "يقع {{count}} أصول في فئة المراقبة (41–70).",
watchExplanation_many: "يقع {{count}} أصلًا في فئة المراقبة (41–70).",
watchExplanation_other: "يقع {{count}} أصل في فئة المراقبة (41–70).",
watchRecommended: "خطط للتفتيشات أو الإصلاح قبل أن تنتقل إلى الحالة الضعيفة.",
watchCta: "تصفية فئة المراقبة",
unscoredExplanation_zero: "لا يوجد لدى {{count}} أصل تقييم حالة حتى الآن.",
unscoredExplanation_one: "لا يوجد لدى أصل واحد تقييم حالة حتى الآن.",
unscoredExplanation_two: "لا يوجد لدى أصلين تقييم حالة حتى الآن.",
unscoredExplanation_few: "لا يوجد لدى {{count}} أصول تقييم حالة حتى الآن.",
unscoredExplanation_many: "لا يوجد لدى {{count}} أصلًا تقييم حالة حتى الآن.",
unscoredExplanation_other: "لا يوجد لدى {{count}} أصل تقييم حالة حتى الآن.",
unscoredRecommended: "أكمل بيانات ملف تعريف الأصل وأجرِ الفحوصات ليُطبَّق التقييم.",
unscoredCta: "فتح التصفية",
balancedExplanation: "لا توجد أصول في هذا العرض ضمن الحالة الضعيفة أو فئة المراقبة.",
balancedRecommended: "حافظ على تحديث التفتيشات وأوامر العمل للحفاظ على استقرار التقييمات.",
refineCta: "تصفية القائمة",
exportCsvLabel: "تصدير الأصول الظاهرة (CSV)",
},
cancel: "إلغاء",
selected_one: "عنصر واحد مُحدد",
selected_other: "{{count}} عنصر مُحدد",
clearVisible: "إلغاء تحديد الظاهر",
allVisible: "كل الظاهر",
exportCsv: "تصدير CSV",
bulkExportA11y: "تصدير الأصول المحددة كـ CSV",
bulkSelectAllA11y: "تحديد جميع الأصول الظاهرة",
bulkDeselectAllA11y: "إلغاء تحديد الظاهر",
printLabels: "طباعة الملصقات",
assignTeam: "تعيين فريق",
assignToTeam: "تعيين للفريق",
personal: "شخصي",
unknownTeam: "فريق غير معروف",
qrPrintTitle: "طباعة ملصقات للأصول المحددة",
exportNoSelectionTitle: "لم يُحدد أصل",
exportNoSelectionBody: "حدد أصلًا ظاهرًا واحدًا على الأقل للتصدير.",
exportCopiedTitle: "تم نسخ التصدير",
exportCopiedBody_one: "نُسخ صف أصل واحد كـ CSV.",
exportCopiedBody_other: "نُسخ {{count}} صف أصول كـ CSV.",
exportErrorTitle: "خطأ",
exportErrorBody: "تعذّر تحديث الأصول.",
typeChip: "النوع",
sortChip: "الفرز",
healthChip: "الصحة",
relationshipChip: "العلاقة",
typeAll: "كل الأنواع",
typeCar: "مركبة",
typeProperty: "مكان",
typeEquipment: "معدّات",
typeOther: "أخرى",
kindAll: "الكل",
kindPlaces: "الأماكن",
kindEquipment: "المعدّات",
kindVehicles: "المركبات",
sortNewest: "الأحدث أولًا",
sortOldest: "الأقدم أولًا",
sortNameAsc: "الاسم أ–ي",
sortNameDesc: "الاسم ي–أ",
sortLastInspected: "آخر تفتيش",
sortMostInspections: "أكثر التفتيشات",
healthAny: "أي درجة صحة",
healthLt80: "درجة أقل من 80",
healthLt60: "درجة أقل من 60",
relationshipAll: "أي علاقة",
groupType: "النوع",
groupTeam: "الفريق",
viewActivity: "عرض النشاط",
signalNoInspection: "لا تفتيش",
signalNoData: "لا بيانات",
loadingMore: "جارٍ تحميل المزيد…",
endOfList_one: "‏أصل واحد — هذه كل النتائج",
endOfList_other: "‏{{count}} أصل — هذه كل النتائج",
endOfListInView_one: "‏أصل واحد في هذا العرض",
endOfListInView_other: "‏{{count}} أصل في هذا العرض",
signalScore: "الدرجة {{score}}",
signalNoHealthScore: "لا درجة صحة",
signalRisk: "مخاطر {{level}}",
signalNoRisk: "لا درجة مخاطر",
signalNotScored: "بلا تقييم",
healthGood: "جيدة",
healthWatch: "مراقبة",
healthPoor: "ضعيفة",
riskLow: "منخفض",
riskMedium: "متوسط",
riskHigh: "مرتفع",
riskExtreme: "شديد",
csvHeaderAsset: "أصل",
csvHeaderType: "النوع",
csvHeaderHealthStatus: "حالة الصحة",
csvHeaderHealthScore: "درجة الصحة",
csvHeaderRisk: "المخاطر",
csvHeaderRiskScore: "درجة المخاطر",
csvHeaderOpenJobs: "مهام مفتوحة",
csvHeaderOverdueJobs: "مهام متأخرة",
csvHeaderLastInspection: "آخر تفتيش",
csvHeaderCreated: "أُنشئ",
csvExportName: "الاسم",
csvExportType: "النوع",
csvExportTeam: "الفريق",
csvExportCreated: "أُنشئ",
csvExportUpdated: "حُدّث",
insightStripTitle: "رؤية الصحة",
healthStatusHeadline: "{{critical}} حرجة · {{warning}} تحت المراقبة",
healthStatusSecondary: "{{good}} بحالة جيدة · {{unscored}} بلا درجة",
queueAttention: "تحتاج إلى عناية",
queueAll: "كل الأصول",
queueShared: "مشترك",
queueTablistA11y: "عرض قائمة الأصول",
inspectPriority: "فحص الأولوية",
inspectPriorityA11y: "فتح الأصل الأكثر أولوية الذي يحتاج انتباهًا",
advancedFiltersTitle: "عوامل تصفية متقدمة وفرز",
advancedFiltersSummary_one: "{{count}} تصفية نشطة",
advancedFiltersSummary_other: "{{count}} تصفية نشطة",
advancedFiltersSummaryEmpty: "النوع والصحة والفرز والتجميع والنطاق",
advancedFiltersExpand: "إظهار عوامل التصفية",
advancedFiltersCollapse: "إخفاء عوامل التصفية",
emptyAttentionClearTitle: "لا يوجد ما يحتاج انتباهًا",
emptyAttentionClearSub: "جميع الأصول في هذا النطاق بحالة جيدة أو بلا درجة.",
emptyAttentionShowAll: "عرض كل الأصول",
emptySharedTitle: "لا يوجد شيء مشترك معك",
emptySharedSub: "تظهر هنا الأصول التي تشاركها معك مساحة عمل أخرى.",
subtitleOwned_zero: "لا أصول",
subtitleOwned_two: "أصلان",
subtitleOwned_few: "{{count}} أصول",
subtitleOwned_many: "{{count}} أصلًا",
subtitleShared_zero: "لا أصول مُشاركة معك",
subtitleShared_two: "أصلان مُشاركان معك",
subtitleShared_few: "{{count}} أصول مُشاركة معك",
subtitleShared_many: "{{count}} أصلًا مُشاركًا معك",
selected_zero: "لم يُحدد شيء",
selected_two: "عنصران مُحددان",
selected_few: "{{count}} عناصر مُحددة",
selected_many: "{{count}} عنصرًا مُحددًا",
exportCopiedBody_zero: "لم يُنسخ أي صف.",
exportCopiedBody_two: "نُسخ صفا أصلين كـ CSV.",
exportCopiedBody_few: "نُسخت {{count}} صفوف أصول كـ CSV.",
exportCopiedBody_many: "نُسخ {{count}} صفًّا من الأصول كـ CSV.",
endOfList_zero: "‏لا أصول — هذه كل النتائج",
endOfList_two: "‏أصلان — هذه كل النتائج",
endOfList_few: "‏{{count}} أصول — هذه كل النتائج",
endOfList_many: "‏{{count}} أصلًا — هذه كل النتائج",
endOfListInView_zero: "‏لا أصول في هذا العرض",
endOfListInView_two: "‏أصلان في هذا العرض",
endOfListInView_few: "‏{{count}} أصول في هذا العرض",
endOfListInView_many: "‏{{count}} أصلًا في هذا العرض",
advancedFiltersSummary_zero: "لا تصفيات نشطة",
advancedFiltersSummary_two: "تصفيتان نشطتان",
advancedFiltersSummary_few: "{{count}} تصفيات نشطة",
advancedFiltersSummary_many: "{{count}} تصفية نشطة",
moreActions: "المزيد من الإجراءات",
queueRetired: "خارج الخدمة نهائيًا",
},
contacts: {
emptyTitle: "لا توجد جهات اتصال مرتبطة بعد",
emptyDescription: "اربط المالكين أو المستأجرين أو المقاولين أو المديرين — ثم شارك الوصول في الوقت نفسه.",
emptyWithRecipients_one: "تلقى {{count}} شخص تقريرًا عن هذا الأصل لكنه غير مرتبط بعد. اربطه للحفاظ على العلاقة مع الأصل.",
emptyWithRecipients_other: "تلقى {{count}} شخص تقارير عن هذا الأصل لكنهم غير مرتبطين بعد. اربطهم للحفاظ على العلاقة مع الأصل.",
linkContact: "ربط جهة اتصال",
reportRecipients: "مستلمو التقارير",
recipientCount_one: "{{count}} مستلم",
recipientCount_other: "{{count}} مستلم",
emptyWithRecipients_zero: "لم يتلقَّ أحد تقريرًا عن هذا الأصل بعد.",
emptyWithRecipients_two: "تلقى شخصان تقارير عن هذا الأصل لكنهما غير مرتبطين بعد. اربطهما للحفاظ على العلاقة مع الأصل.",
emptyWithRecipients_few: "تلقى {{count}} أشخاص تقارير عن هذا الأصل لكنهم غير مرتبطين بعد. اربطهم للحفاظ على العلاقة مع الأصل.",
emptyWithRecipients_many: "تلقى {{count}} شخصًا تقارير عن هذا الأصل لكنهم غير مرتبطين بعد. اربطهم للحفاظ على العلاقة مع الأصل.",
recipientCount_zero: "لا مستلمين",
recipientCount_two: "مستلمان",
recipientCount_few: "{{count}} مستلمين",
recipientCount_many: "{{count}} مستلمًا",
},
shared: {
  contactRelationship: {
    other: "أخرى",
    manager: "المدير",
    occupant: "الشاغل",
    site_contact: "جهة الاتصال في الموقع",
    reviewer: "يراجع العمل",
    approver: "يوافق على العمل",
    observer: "على اطلاع",
    supplier: "المورّد",
    contractor: "المقاول",
    client: "العميل",
    landlord: "المؤجر",
    tenant: "المستأجر",
    owner: "المالك",
    recipient: "يتلقى التقارير",
    requester: "يبلّغ عن المشكلات",
    assignee: "ينفذ العمل",
  },
  disposalMethod: {
    other: "أخرى",
    donated: "تم التبرع به",
    transferred: "تم نقله",
    returned: "أُعيد إلى المؤجر",
    recycled: "أُعيد تدويره",
    scrapped: "تم تكهينه",
    sold: "تم بيعه",
  },
  retirementReason: {
    other: "أخرى",
    lost: "مفقود أو مسروق",
    replaced: "تم استبداله",
    decommissioned: "أُخرج من الخدمة",
    disposed: "تم التخلص منه",
    sold: "تم بيعه",
  },
  decommissionReason: {
    other: "أخرى",
    relocated: "نُقل إلى مكان آخر",
    seasonal: "إيقاف موسمي",
    replaced: "تم استبداله",
    fault: "عطل",
    end_of_life: "نهاية العمر",
  },
  standing: {
    active: "نشط",
    retired: "خارج الخدمة نهائيًا",
    archived: "مؤرشف",
    decommissioned: "خارج الخدمة",
    planned: "لم يدخل الخدمة بعد",
    in_service: "في الخدمة",
  },
  complianceTag: {
    warranty_active: "ضمن الضمان",
    insurance_required: "التأمين مطلوب",
    ppe: "معدات الحماية",
    pressure_system: "نظام الضغط",
    lifting_equipment: "معدات الرفع",
    vehicle_roadworthy: "مركبة صالحة للسير",
    energy_performance: "أداء الطاقة (EPC)",
    water_hygiene: "نظافة المياه",
    gas_safety: "سلامة الغاز",
    electrical_safety: "السلامة الكهربائية",
    fire_safety: "السلامة من الحريق",
  },
  operatingContext: {
    operational: "العمليات اليومية",
    storage: "تخزين",
    shared_use: "استخدام مشترك",
    staff_only: "للموظفين فقط",
    customer_facing: "يستخدمه العملاء",
  },
  lifecycle: {
    decommissioned: "خارج الخدمة",
    under_renovation: "قيد التجديد",
    partially_operational: "في الخدمة جزئيًا",
    operational: "في الخدمة",
    handover: "قيد التسليم",
    partially_developed: "مكتمل جزئيًا",
    in_development: "قيد الإنشاء",
    planned: "مخطط",
  },
  otherDomain: {
    other: "أخرى",
    miscellaneous: "متفرقات",
    storage: "تخزين",
    fixture: "تجهيزات ثابتة",
    inventory: "مخزون",
    signage: "لافتات",
    it: "معدات تقنية المعلومات",
    furniture: "أثاث",
  },
  installation: {
    vehicle_mounted: "مثبت على مركبة",
    portable: "محمول",
    fixed: "ثابت",
  },
  powerSource: {
    pneumatic: "هوائي",
    hydraulic: "هيدروليكي",
    manual: "يدوي",
    gas: "غاز",
    petrol: "بنزين",
    diesel: "ديزل",
    battery: "بطارية",
    electric: "كهربائي",
  },
  equipmentClass: {
    other: "أخرى",
    kitchen_equipment: "معدات المطبخ",
    appliance: "جهاز",
    electrical_distribution: "توزيع الكهرباء",
    fire_system: "نظام الحريق",
    safety_equipment: "معدات السلامة",
    cleaning_machine: "آلة تنظيف",
    machine: "آلة",
    power_tool: "أداة كهربائية",
    lift: "مصعد",
    compressor: "ضاغط",
    forklift: "رافعة شوكية",
    pump: "مضخة",
    generator: "مولد",
    boiler: "غلاية",
    hvac: "التدفئة والتبريد",
  },
  vehicleUsage: {
    plant_support: "دعم المعدات",
    site_use: "استخدام في الموقع",
    passenger_transport: "نقل ركاب",
    delivery: "توصيل",
    fleet: "أسطول",
    personal: "شخصي",
  },
  vehicleFuel: {
    other: "أخرى",
    lpg: "غاز مسال",
    electric: "كهربائي",
    hybrid: "هجين",
    diesel: "ديزل",
    petrol: "بنزين",
  },
  vehicleClass: {
    other: "أخرى",
    plant_vehicle: "مركبة إنشاءات",
    bus: "حافلة",
    motorcycle: "دراجة نارية",
    trailer: "مقطورة",
    truck: "شاحنة",
    van: "فان",
    car: "سيارة",
  },
  occupancy: {
    new_build: "بناء جديد",
    under_renovation: "قيد التجديد",
    partially_occupied: "مشغول جزئيًا",
    vacant: "شاغر",
    occupied: "مشغول",
  },
  propertySubtype: {
    other: "أخرى",
    depot: "مرآب",
    plant: "منشأة",
    yard: "ساحة",
    workshop: "ورشة",
    factory: "مصنع",
    warehouse: "مستودع",
    mixed_use: "استخدام مختلط",
    education: "مدرسة أو جامعة",
    healthcare: "رعاية صحية",
    hospitality: "فندق أو مطعم",
    retail: "متجر",
    office: "مكتب",
    holiday_rental: "إيجار عطلات",
    student_accommodation: "سكن طلابي",
    studio: "استوديو",
    townhouse: "منزل متلاصق",
    flat: "شقة سكنية",
    apartment: "شقة",
    house: "منزل",
  },
assetType: {
car: "مركبة",
property: "مكان",
equipment: "معدة",
other: "أخرى",
},
externalIdType: {
vin: "رقم الهيكل (VIN)",
serial: "الرقم التسلسلي",
registration: "رقم التسجيل",
barcode: "الرمز الشريطي",
custom: "معرّف مخصص",
},
documentType: {
certificate: "شهادة",
warranty: "ضمان",
compliance: "الامتثال",
general: "عام",
},
criticality: {
low: "منخفضة",
medium: "متوسطة",
high: "مرتفعة",
critical: "حرجة",
},
mobility: {
fixed: "ثابت",
movable: "قابل للنقل",
mobile: "متنقل",
},
propertyFamily: {
residential: "سكني",
commercial: "تجاري",
industrial: "صناعي",
},
furnishedStatus: {
unfurnished: "غير مفروش",
part_furnished: "مفروش جزئيًا",
fully_furnished: "مفروش بالكامل",
},
propertySystem: {
hvac: "التدفئة والتهوية والتكييف",
electrical: "الكهرباء",
plumbing: "السباكة",
fire_alarm: "إنذار الحريق",
sprinklers: "مرشات إطفاء الحريق",
security_alarm: "إنذار أمني",
access_control: "التحكم في الدخول",
cctv: "كاميرات المراقبة",
lift: "مصعد",
solar: "الطاقة الشمسية",
},
vehicleTransmission: {
manual: "يدوي",
automatic: "أوتوماتيكي",
semi_automatic: "نصف أوتوماتيكي",
},
vehicleConditionFlag: {
road_legal: "صالحة للسير قانونيًا",
insured: "مؤمَّنة",
under_warranty: "ضمن الضمان",
service_contract: "عقد صيانة",
high_mileage: "مسافة مقطوعة عالية",
off_road_use: "استخدام على الطرق الوعرة",
},
equipmentConditionFlag: {
service_contract: "عقد صيانة",
under_warranty: "ضمن الضمان",
calibration_required: "تتطلب معايرة",
inspection_required: "تتطلب فحصًا",
safety_critical: "حرجة للسلامة",
},
equipmentCapacityUnit: {
litres: "لتر",
tonnes: "طن",
other: "أخرى",
},
equipmentSafetyClass: {
general: "عامة",
safety_critical: "حرجة للسلامة",
lifting: "رفع",
pressure: "ضغط",
electrical: "كهربائية",
fire_safety: "السلامة من الحريق",
},
equipmentOperatingEnvironment: {
indoor: "داخلية",
outdoor: "خارجية",
mixed: "مختلطة",
wet_area: "منطقة رطبة",
dusty: "مغبرة",
high_temperature: "حرارة مرتفعة",
cold_environment: "بيئة باردة",
},
otherRiskTag: {
fragile: "قابل للكسر",
high_value: "عالي القيمة",
regulated: "خاضع للتنظيم",
public_facing: "يتعامل مع الجمهور",
portable: "محمول",
safety_critical: "حرج للسلامة",
},
otherMiscKind: {
general: "عام / غير مصنّف",
documentation: "الوثائق والسجلات",
consumables: "المواد الاستهلاكية",
spare_parts: "قطع الغيار",
tooling: "الأدوات والمعدات",
display_marketing: "العرض والتسويق",
safety_supplies: "مستلزمات السلامة",
mixed_stock: "مخزون مختلط",
},
compliancePosture: {
clear: "سليم",
watch: "مراقبة",
action: "يتطلب إجراءً",
},
externalIdPlaceholder: {
vin: "مثال: 1HGBH41JXMN109186",
serial: "مثال: SN-2024-00123",
registration: "مثال: ABC 1234",
barcode: "مثال: امسح الرمز الشريطي أو رمز QR أو أدخل قيمته",
custom: "أدخل مرجعًا مخصصًا...",
},
},
documents: {
add: {
  editHint: "غيّر التواريخ أو التذكير أو العنوان أو الملاحظات، ثم اضغط حفظ المستند. يبقى الملف كما هو.",
  editTitle: "تعديل تفاصيل المستند",
pickTitle: "إضافة مستند",
pickBody: "اختر طريقة إرفاق المستند.",
labels: {
  validMonths: "صالح {{months}} شهرًا",
  subtype: "نوع المستند بالتحديد",
referenceNumber: "رقم الشهادة / المرجع",
documentType: "نوع المستند",
title: "العنوان",
file: "الملف",
issueDate: "تاريخ الإصدار",
expiryDate: "تاريخ الانتهاء",
reminderDays: "ذكّرني بهذا العدد من الأيام قبل انتهاء الصلاحية",
notes: "ملاحظات",
validator: "من يراجعه ويعتمده؟",
validatorHint: "يتلقى إشعارًا ومهمة حتى يعتمده أو يرفضه.",
validatorNoTeam: "لا يوجد لهذا الأصل فريق مسؤول حتى الآن، لذا يبقى التصديق معك.",
validatorMe: "أنا",
validatorApprover: "مصادق الأصل",
},
placeholders: {
referenceNumber: "مثال: ABC123456 (اختياري)",
title: "مثال: شهادة سلامة الغاز",
titleRenewed: "شهادة مجدَّدة",
file: "اختر ملفًا لتحميله",
issueDate: "YYYY-MM-DD",
expiryDate: "YYYY-MM-DD",
notes: "ملاحظات خاصة حول هذا المستند",
},
a11y: {
saveDocument: "حفظ المستند",
},
actions: {
saving: "جارٍ الحفظ...",
submit: "حفظ المستند",
},
ai: {
title: "تفاصيل المستند بالذكاء الاصطناعي",
suggestAction: "اقترح التفاصيل بالذكاء الاصطناعي",
prompt: "استخرج العنوان والنوع والتواريخ من الملف المحمَّل عندما تكون متصلًا بالإنترنت.",
reviewHint: "راجع الحقول المقترحة قبل الحفظ. لا تزال الشهادات تتطلب تصديقًا.",
applyAll: "تطبيق جميع الاقتراحات",
providerName: "المزوّد / الجهة المُصدرة",
assetIdentifier: "معرّف الأصل في المستند",
},
alerts: {
photoPermission: "اسمح بالوصول إلى مكتبة الصور لاختيار صورة المستند.",
cameraPermission: "اسمح بالوصول إلى الكاميرا لتصوير مستند.",
documentPicker: "تعذّر فتح أداة اختيار الملفات.",
assetNotFound: "الأصل غير موجود.",
titleRequired: "أدخل عنوان المستند.",
fileRequired: "اختر ملفًا لتحميله.",
signInRequired: "سجّل الدخول مرة أخرى قبل حفظ هذا المستند.",
saveFailed: "تعذّر حفظ هذا المستند.",
},
      energy: {
        scheme: "نوع الشهادة",
        schemeEPC: "EPC (شهادة أداء الطاقة)",
        schemeDEC: "DEC (شهادة العرض)",
        rating: "التصنيف",
        score: "الدرجة",
        scorePlaceholder: "مثال: 68",
        isLet: "المبنى مؤجَّر",
        isLetHint: "يحتاج المبنى المؤجَّر في إنجلترا وويلز إلى E أو أفضل.",
        belowMinimum: "أقل من E: لا يمكن تأجير هذا المبنى بهذا التصنيف دون إعفاء.",
        ratingRequired: "اختر التصنيف من الشهادة.",
      },
},
},
relationships: {
  alerts: {
    duplicateCheckFailedTitle: "تعذّر التحقق من التكرارات",
    markDistinct: "لا، إنهما مختلفان",
    markDuplicate: "نعم، علّمه كتكرار محتمل",
    duplicateFoundBody: "يشبه {{name}} هذا الأصل. هل هو نفسه؟",
    duplicateFoundTitle: "قد يكون هذا هو الأصل نفسه",
    noDuplicatesBody: "لا يوجد أصل آخر يطابق هذا الأصل.",
    noDuplicatesTitle: "لم يتم العثور على تكرارات",
    mergeFailedTitle: "تعذّر الدمج",
    merge: "دمج",
    mergeBody: "يُعلَّم هذا الأصل كمدمج. ويُحتفظ بسجله.",
    mergeTitle: "دمج هذا الأصل في السجل الآخر؟",
    canonicalFailedTitle: "تعذّر تحديد السجل الرئيسي",
    removeFailedTitle: "تعذّرت إزالة الرابط",
    remove: "إزالة",
    cancel: "إلغاء",
    removeBody: "يبقى الأصلان. تتم إزالة الرابط بينهما فقط.",
    removeTitle: "إزالة هذا الرابط؟",
    tryAgain: "تحقق من اتصالك وحاول مرة أخرى.",
    updateFailedTitle: "تعذّر حفظ الرابط",
    addFailedTitle: "تعذّرت إضافة الرابط",
    selectAssetBody: "ابحث عن الأصل المراد ربطه، ثم اضغط عليه.",
    selectAssetTitle: "اختر أصلًا",
  },
views: {
list: "قائمة",
tree: "شجرة",
map: "خريطة",
},
refine: "تصفية",
refineA11y: "تصفية الخريطة",
refineTitle: "تصفية الخريطة",
refineShow: "إظهار",
refineRisk: "المخاطر",
refineCriticality: "الأهمية",
refineDepth: "العمق",
refineColour: "التلوين حسب",
refineLayout: "التخطيط",
filter: {
all: "الكل",
hierarchy: "التسلسل الهرمي",
dependency: "الاعتمادية",
association: "الارتباط",
duplicate: "التكرار",
inbound: "الواردة",
outbound: "الصادرة",
},
riskOnly: "ذات الصلة بالمخاطر فقط",
highlightCritical: "إبراز الحرجة",
hops_one: "مستوى واحد",
hops_other: "{{count}} مستوى",
colour: {
combined: "الكل",
health: "الحالة",
type: "النوع",
risk: "فئة الرابط",
},
layout: {
auto: "تلقائي",
hierarchy: "هرمي",
force: "شبكي",
radial: "شعاعي",
grid: "شبكة",
},
groups: {
parents: "الأصول الأم / الحاويات",
children: "الأصول الفرعية / المحتواة",
dependsOn: "يعتمد على",
supports: "يدعم / يؤثر على",
related: "ذات صلة",
canonical: "الأصل المعتمد",
duplicates: "تكرارات محتملة",
},
emptyTitle: "لم يتم تحديد علاقات بعد",
emptyBody: "اربط أصلًا أمًا أو مكونًا أو أصلًا نظيرًا لتُعرف الاعتماديات والأثر.",
linkAsset: "ربط أصل",
linkAssetA11y: "ربط أصل",
checkDuplicates: "التحقق من التكرارات",
checkDuplicatesA11y: "البحث عن أصول مكررة",
setCanonical: "تعيين كمعتمد",
merge: "دمج",
compare: "مقارنة",
comparison: "المقارنة",
loadingGraph: "جارٍ تحميل الرسم...",
mapAssets_one: "أصل واحد",
mapAssets_other: "{{count}} أصل",
mapLinks_one: "رابط واحد",
mapLinks_other: "{{count}} رابط",
mapImpacts_zero: "يؤثر على {{count}} من الأصول ذات الصلة من هنا",
mapImpacts_one: "يؤثر على أصل واحد ذي صلة من هنا",
mapImpacts_two: "يؤثر على أصلين ذوي صلة من هنا",
mapImpacts_few: "يؤثر على {{count}} من الأصول ذات الصلة من هنا",
mapImpacts_many: "يؤثر على {{count}} من الأصول ذات الصلة من هنا",
mapImpacts_other: "يؤثر على {{count}} من الأصول ذات الصلة من هنا",
openAsset: "فتح {{name}}",
editLink: "تعديل الرابط مع {{name}}",
unlink: "إلغاء ربط {{name}}",
treeLoading: "جارٍ التحميل…",
treeThisAsset: "هذا الأصل",
treeChildren_one: "أصل فرعي واحد",
treeChildren_other: "{{count}} أصل فرعي",
riskRelevant: "ذات صلة بالمخاطر",
informational: "معلوماتية",
linkCreated: "تم إنشاء الرابط",
linkAnother: "ربط آخر",
done: "تم",
type: {
contains: "يحتوي على",
part_of: "جزء من",
located_in: "يقع في",
depends_on: "يعتمد على",
supports: "يدعم",
connected_to: "متصل بـ",
serves: "يخدم",
powered_by: "يُشغَّل بواسطة",
monitored_by: "يُراقَب بواسطة",
associated_with: "مرتبط بـ",
backup_for: "احتياطي لـ",
replacement_for: "بديل لـ",
assigned_to: "مُسند إلى",
installed_in: "مُركَّب في",
maintained_with: "يُصان مع",
possible_duplicate_of: "تكرار محتمل لـ",
duplicate_of: "تكرار لـ",
merged_into: "مُدمج في",
},
verb: {
contains: "يحتوي على",
part_of: "جزء من",
located_in: "يقع في",
depends_on: "يعتمد على",
supports: "يدعم",
connected_to: "متصل بـ",
serves: "يخدم",
powered_by: "يُشغَّل بواسطة",
monitored_by: "يُراقَب بواسطة",
associated_with: "مرتبط بـ",
backup_for: "احتياطي لـ",
replacement_for: "بديل لـ",
assigned_to: "مُسند إلى",
installed_in: "مُركَّب في",
maintained_with: "يُصان مع",
possible_duplicate_of: "قد يكون تكرارًا لـ",
duplicate_of: "تكرار لـ",
merged_into: "دُمج في",
},
category: {
hierarchy: "التسلسل الهرمي",
dependency: "الاعتماديات",
association: "ذات صلة",
duplicate: "التكرارات",
},
propagation: {
none: "لا شيء",
informational: "معلوماتية",
contributes_to_parent: "تسهم في الأصل الأم",
contributes_to_dependent: "تسهم في الأصل التابع",
bidirectional_warning: "تحذير في الاتجاهين",
},
form: {
addTitle: "إضافة علاقة",
editTitle: "تعديل العلاقة",
close: "إغلاق",
relatedAsset: "الأصل المرتبط",
chooseRelated: "اختر الأصل الذي يرتبط به هذا الأصل",
choose: "اختيار",
change: "تغيير",
done: "تم",
edit: "تعديل",
relationshipType: "نوع العلاقة",
swap: "عكس",
swapA11y: "عكس الاتجاه",
riskAndNotes: "المخاطر والملاحظات",
criticality: "الأهمية",
countsTowardsRisk: "يُحتسب ضمن المخاطر",
riskRelevant: "ذات صلة بالمخاطر",
informationalOnly: "معلوماتية فقط",
informationalHint: "علاقات «{{type}}» معلوماتية.",
propagation: "انتشار المخاطر",
reasonPlaceholder: "سبب الأهمية (اختياري)",
reasonA11y: "سبب الأهمية",
notesPlaceholder: "ملاحظات (اختياري)",
notesA11y: "ملاحظات",
notes: "ملاحظات",
cancel: "إلغاء",
add: "إضافة العلاقة",
save: "حفظ التغييرات",
saving: "جارٍ الحفظ...",
and: "{{a}} و{{b}}",
selectAssetTitle: "اختر أصلًا",
selectAssetBody: "اختر أصلًا لربطه.",
couldNotAdd: "تعذّر إضافة العلاقة",
tryAgain: "يرجى المحاولة مرة أخرى.",
},
edge: {
added: "أُضيفت في {{date}}",
edit: "تعديل",
remove: "إزالة",
close: "إغلاق",
},
picker: {
  addAsset: "إضافة أصل",
title: "الأصل",
relatedTitle: "الأصل المرتبط",
searchPlaceholder: "ابحث بالاسم أو الموقع أو المعرّف…",
searchA11y: "البحث في الأصول",
clearSearch: "مسح البحث",
allTypes: "كل الأنواع",
searching: "جارٍ البحث في كل الأصول…",
noneYet: "لا توجد أصول بعد.",
noMatchHint: "لا توجد أصول مطابقة. جرّب اسمًا آخر أو أزل عامل تصفية النوع.",
noMatch: "لا توجد أصول مطابقة.",
showingFirst: "يتم عرض أول {{shown}} من {{total}}. تابع الكتابة لتضييق النتائج.",
noAsset: "بدون أصل",
clearSelection: "مسح التحديد",
done: "تم",
close: "إغلاق",
chooseAsset: "اختر أصلًا",
changeA11y: "الأصل: {{name}}. تغيير",
},
hops_zero: "لا مستويات",
hops_two: "مستويان",
hops_few: "{{count}} مستويات",
hops_many: "{{count}} مستوى",
mapAssets_zero: "لا أصول",
mapAssets_two: "أصلان",
mapAssets_few: "{{count}} أصول",
mapAssets_many: "{{count}} أصلًا",
mapLinks_zero: "لا روابط",
mapLinks_two: "رابطان",
mapLinks_few: "{{count}} روابط",
mapLinks_many: "{{count}} رابطًا",
treeChildren_zero: "لا أصول فرعية",
treeChildren_two: "أصلان فرعيان",
treeChildren_few: "{{count}} أصول فرعية",
treeChildren_many: "{{count}} أصلًا فرعيًا",
},
relationshipNode: {
current: "الأصل الحالي",
unscored: "الحالة غير مقيّمة",
loadingImpact: "جارٍ تحميل الأثر…",
impacts_one: "يؤثر على أصل مرتبط واحد",
impacts_other: "يؤثر على {{count}} أصل مرتبط",
open: "فتح الأصل",
addRelationship: "إضافة علاقة",
viewWork: "عرض الأعمال المتأثرة",
close: "إغلاق",
impacts_zero: "لا يؤثر على أصول مرتبطة",
impacts_two: "يؤثر على أصلين مرتبطين",
impacts_few: "يؤثر على {{count}} أصول مرتبطة",
impacts_many: "يؤثر على {{count}} أصلًا مرتبطًا",
},
documentsSection: {
  editDetails: "تعديل التفاصيل",
statusAll: "الكل",
statusExpired: "منتهي الصلاحية",
statusExpiringSoon: "قارب على الانتهاء",
statusValid: "صالح",
statusPending: "قيد الانتظار",
statusRejected: "مرفوضة",
statusSupersededOrUndated: "مُستبدَل أو غير مؤرَّخ",
typeAll: "جميع الأنواع",
typeCertificates: "الشهادات",
typeWarranty: "ضمان",
typeCompliance: "الامتثال",
typeGeneral: "عام",
viewList: "قائمة",
viewTimeline: "الجدول الزمني",
viewCalendar: "التقويم",
viewLabel: "العرض",
loadingDocumentsA11y: "جارٍ تحميل المستندات",
loadingDocumentsText: "جارٍ تحميل المستندات...",
addDocumentA11y: "إضافة مستند",
tryLoadingAgainA11y: "حاول تحميل المستندات مرة أخرى",
refineDocumentsA11y: "تصفية المستندات",
searchDocumentsA11y: "البحث في المستندات",
clearSearchA11y: "مسح البحث",
refineDocumentsTitle: "تصفية المستندات",
rejectionReasonA11y: "سبب الرفض",
reasonPlaceholder: "السبب",
validateInTheirPlace: "التصديق نيابةً عنهم",
openFile: "فتح الملف",
validate: "تصديق",
renew: "تجديد",
replace: "استبدال",
reject: "رفض",
startInspection: "بدء فحص",
createJob: "إنشاء مهمة",
planRenewal: "خطّط لتجديده",
history: "السجل",
closeA11y: "إغلاق",
metaIssued: "تاريخ الإصدار",
metaExpires: "تاريخ الانتهاء",
metaReminder: "التذكير",
metaReminderDays: "{{days}} أيام",
metaSource: "المصدر",
metaFile: "الملف",
metaValidatedBy: "تم التحقق منها بواسطة",
metaPrevious: "السابق",
metaNext: "التالي",
showPreviousMonthA11y: "عرض الشهر السابق",
showNextMonthA11y: "عرض الشهر المقبل",
showTodayA11y: "عرض اليوم",
dateHintA11y: "يعرض المستندات الصادرة أو التي تنتهي صلاحيتها في هذا التاريخ",
documentHistoryTitle: "سجل المستند",
noRenewalHistory: "لا يوجد سجل تجديد حتى الآن.",
historyEntry: "{{index}}. {{title}} - {{date}} - {{status}}",
historyCurrentStatus: "الحالي",
validateDocumentTitle: "التحقق من صحة الوثيقة",
validateDocumentBody: "هل تريد تصديق \"{{title}}\" وجعله نشطًا؟",
cancel: "إلغاء",
reasonRequiredTitle: "السبب مطلوب",
reasonRequiredBody: "أدخل سبب الرفض قبل رفض هذا المستند.",
pageTitle: "المستندات",
pageSub: "الملفات والشهادات والضمانات المحفوظة لهذا الأصل.",
loadErrorText: "تعذر تحميل المستندات",
emptyText: "لا توجد وثائق حتى الآن",
emptySub: "الشهادات والضمانات والأدلة الخاصة بهذا الأصل موجودة هنا، مع تتبع تواريخ انتهاء صلاحيتها.",
tryAgain: "إعادة المحاولة",
addDocumentButton: "إضافة مستند",
viewOptionA11y: "عرض {{label}}",
refine: "تصفية",
searchPlaceholder: "البحث في المستندات...",
rejectDocumentTitle: "رفض المستند",
rejectDocumentBody: "أدخل سبب عدم إمكانية التحقق من صحة هذه الوثيقة.",
openDocumentA11y: "افتح {{title}}",
rejectionReasonPrefix: "سبب الرفض: {{reason}}",
noDocumentDates: "لا توجد تواريخ وثيقة",
documentDateCount_one: "تاريخ مستند واحد",
documentDateCount_other: "{{count}} تاريخ مستند",
dayCellA11y: "{{dateLabel}}. {{eventLabel}}.",
statusPendingValidation: "بانتظار التصديق",
statusSupersededLabel: "استُبدل",
statusNoExpiryRecorded: "لم يتم تسجيل انتهاء الصلاحية",
statusEvidenceMissing: "الأدلة مفقودة",
kindIssued: "صادرة",
kindAdded: "مُضافة",
kindExpires: "تنتهي صلاحيتها",
openDocumentWithStatusA11y: "افتح {{title}}. {{status}}.",
issuedOn: "صدر في {{date}}",
addedOn: "أُضيفت في {{date}}",
expiresOnSuffix: " · تنتهي صلاحيته في {{date}}",
noExpiryRecordedSuffix: " · لم يتم تسجيل انتهاء الصلاحية",
expiresLowerSuffix: " ← تنتهي صلاحيته في {{date}}",
noExpiryRecordedLowerSuffix: " · لم يتم تسجيل انتهاء الصلاحية",
today: "اليوم",
documentDateCount_zero: "لا تواريخ مستندات",
documentDateCount_two: "تاريخا مستند",
documentDateCount_few: "{{count}} تواريخ مستندات",
documentDateCount_many: "{{count}} تاريخ مستند",
},
guideMeSheet: {
subtitle: "اختر شيئًا لإعداده على هذا الأصل. نُبرز لك كل ما عليك الضغط عليه، خطوة بخطوة.",
},
graphInspector: {
selectedLink: "الرابط المحدد",
},
decommissionSheet: {
title: "إخراج من الخدمة",
cancelA11y: "إلغاء إيقاف التشغيل",
reasonLabel: "لماذا يخرج من الخدمة؟",
outOfServiceFromLabel: "خارج الخدمة من",
noteLabel: "الملاحظة",
notePlaceholder: "ما يجب أن يعرفه الفريق — مثال: تصدّع المبادل الحراري، وطُلب الاستبدال.",
noteA11y: "ملاحظة الإخراج من الخدمة",
makeSafeFirstTitle: "اجعله آمنًا أولًا",
makeSafeFirstBodyOn_zero: "يُنشئ أمر عمل يتضمن {{count}} خطوة تأمين كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOn_one: "يُنشئ أمر عمل يتضمن خطوة تأمين واحدة كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOn_two: "يُنشئ أمر عمل يتضمن خطوتَي تأمين كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOn_few: "يُنشئ أمر عمل يتضمن {{count}} خطوات تأمين كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOn_many: "يُنشئ أمر عمل يتضمن {{count}} خطوةَ تأمين كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOn_other: "يُنشئ أمر عمل يتضمن {{count}} خطوة تأمين كفحص لاحق. يترك الأصل الخدمة عند التحقق من أمر العمل هذا.",
makeSafeFirstBodyOff: "لا يوجد أمر عمل. الأصل يغادر الخدمة الآن؛ أضف ملاحظة تقول من قرر.",
makeSafeSwitchA11y: "أنشئ أمر عمل لتأمين الأصل قبل خروجه من الخدمة",
confirmRaise: "إنشاء أمر عمل التأمين",
confirmTakeOut: "إخراج من الخدمة الآن",
},
dataQuality: {
bandComplete: "ملف التعريف مكتمل",
bandPartial: "ملف التعريف مكتمل جزئيًا",
bandMissing: "التفاصيل مفقودة",
title: "ملف تعريف الأصول",
subtitleAllComplete_one: "حقل ملف التعريف المنطبق الوحيد ({{total}}) مكتمل.",
subtitleAllComplete_other: "جميع حقول ملف التعريف المنطبقة ({{total}}) مكتملة.",
subtitleAddLead: "أضف {{label}} — {{unlock}}.",
subtitleAddMissing: "أضف التفاصيل المنظمة المفقودة لإكمال ملف تعريف الأصول هذا.",
addGapA11y: "أضف {{label}} — {{unlock}}",
applySuggestions_one: "تطبيق اقتراح ذكاء اصطناعي واحد",
applySuggestions_other: "تطبيق {{count}} اقتراح ذكاء اصطناعي",
confidenceMediumLabel: "ثقة متوسطة",
confidenceMediumBody: "يعمل الذكاء الاصطناعي بتفاصيل محدودة حول هذا الأصل.",
confidenceLowLabel: "ثقة منخفضة",
confidenceLowBody: "يحتوي هذا الأصل على القليل من البيانات المنظمة، لذا تعامل مع مخرجات الذكاء الاصطناعي كنقطة بداية.",
confidenceA11y: "{{label}}. {{body}} تحسين جودة البيانات.",
confidenceBodySuffix: "{{body}} تحسين البيانات ←",
subtitleAllComplete_zero: "لا حقول ملف تعريف منطبقة ({{total}}).",
subtitleAllComplete_two: "حقلا ملف التعريف المنطبقان ({{total}}) مكتملان.",
subtitleAllComplete_few: "جميع حقول ملف التعريف المنطبقة ({{total}}) مكتملة.",
subtitleAllComplete_many: "جميع حقول ملف التعريف المنطبقة ({{total}}) مكتملة.",
applySuggestions_zero: "لا اقتراحات ذكاء اصطناعي لتطبيقها",
applySuggestions_two: "تطبيق اقتراحي ذكاء اصطناعي",
applySuggestions_few: "تطبيق {{count}} اقتراحات ذكاء اصطناعي",
applySuggestions_many: "تطبيق {{count}} اقتراح ذكاء اصطناعي",
},
activitySection: {
who: "من: {{name}}",
when: "متى: {{when}}",
refineActivity: "تصفية النشاط",
refine: "تصفية",
searchActivityPlaceholder: "البحث في النشاط…",
searchActivityA11y: "البحث في النشاط",
clearSearchA11y: "مسح البحث",
hideSearchA11y: "إخفاء البحث",
noActivityOnDate: "لا يوجد نشاط في هذا التاريخ",
noActivityHint: "اختر يومًا آخر، أو غيّر التصفية أو البحث.",
view: "العرض",
timeline: "الجدول الزمني",
calendar: "التقويم",
status: "الحالة",
all: "الكل",
outstanding: "معلّق",
planned: "مخطط له",
completed: "مكتمل",
inspections: "التفتيش",
jobs: "المهام",
documents: "المستندات",
},
actionsSection: {
uploadDocumentA11y: "تحميل المستند",
uploadDoc: "تحميل الوثيقة",
},
portfolioGraphPanel: {
couldNotLinkTitle: "تعذر الارتباط",
createRelationshipFailed: "فشل إنشاء العلاقة.",
couldNotRemoveTitle: "تعذّرت الإزالة",
failed: "فشلت العملية.",
emptyTitle: "لا توجد أصول لتصورها",
emptySub: "أنشئ أصلك الأول لرؤية الشبكة.",
useListView: "استخدم عرض القائمة",
},
portfolioContextualBar: {
linkTypeHeader: "نوع الربط · {{source}} ← {{target}}",
defaultSourceName: "المصدر",
defaultTargetName: "الهدف",
pickTypeHint: "اختر نوعًا أو استخدم المزيد من الخيارات للحصول على التفاصيل الكاملة.",
moreOptions: "المزيد من الخيارات",
editOnSource: "التعديل على المصدر",
criticalityBadge: "الأهمية: {{criticality}}",
impactsRelated_zero: "يؤثر على {{count}} من الأصول ذات الصلة",
impactsRelated_one: "يؤثر على أصل واحد ذي صلة",
impactsRelated_two: "يؤثر على أصلين ذوي صلة",
impactsRelated_few: "يؤثر على {{count}} من الأصول ذات الصلة",
impactsRelated_many: "يؤثر على {{count}} من الأصول ذات الصلة",
impactsRelated_other: "يؤثر على {{count}} من الأصول ذات الصلة",
connectFromHere: "الربط من هنا",
},
portfolioGraphContextRow: {
exit: "خروج",
connect: "ربط",
},
listRow: {
canRequestWork: "يمكن طلب العمل",
readOnly: "للقراءة فقط",
overdue: "متأخر",
next: "التالي",
nextStepLabel: "{{prefix}}: {{scheduleLabel}} {{time}}",
recommendedRaiseJob: "مستحسن: رفع أمر العمل",
recommendedInspect: "موصى به: فحص",
healthSuffix: "{{status}} الصحة",
needsAttention: "يحتاج إلى الاهتمام",
openNextStep: "فتح {{label}}",
recommendRaiseJobA11y: "الإجراء التالي الموصى به: رفع أمر العمل",
recommendInspectA11y: "الإجراء التالي الموصى به: بدء عملية الفحص",
directionsTo: "الاتجاهات إلى {{name}}",
relationshipsFor: "علاقات {{name}}",
},
shareSection: {
invitePending: "الدعوة معلقة",
inviteRequired: "الدعوة مطلوبة",
active: "نشط",
title: "جهات الاتصال المشتركة",
subtitle: "يمكن لجميع الأشخاص المدرجين هنا فتح هذا الأصل في مساحة العمل المشتركة وفقًا لدورهم وأذوناتهم.",
shareWithContact: "شارك مع جهة الاتصال",
loading: "جارٍ تحميل جهات الاتصال المشتركة...",
empty: "لا توجد جهات اتصال لديها حق الوصول إلى هذا الأصل حتى الآن. شاركه مع جهة اتصال حتى تتمكن من طلب الفحوصات أو اقتراح أوامر العمل.",
linkedContactFallback: "جهة الاتصال المرتبطة",
noRelationshipLinked: "لا توجد علاقة أصول مرتبطة",
collaborationRole: "دور التعاون: {{role}}",
collaborationRoleWithStatus: "الدور التعاوني: {{role}} · {{status}}",
canView: "يمكنه العرض",
lockedFeatureName: "المشاركة مع جهات الاتصال",
canRequestInspection: "يمكنه طلب الفحص",
canProposeJob: "يمكنه اقتراح أمر عمل",
yes: "نعم",
no: "لا",
workspaceVisibility: "ظهور مساحة العمل: {{detail}}",
openRequests: "الطلبات المفتوحة: {{count}}",
openRequestsWithLast: "الطلبات المفتوحة: {{count}} · آخر طلب {{date}}",
openRequestsNoneYet: "الطلبات المفتوحة: {{count}} · لا توجد طلبات بعد",
inviteSentResendHint: "تم إرسال الدعوة. أعد إرسالها إذا لم يتلقوها.",
inviteSendHint: "أرسل دعوة حتى يتمكنوا من ربط حساباتهم والوصول إلى هذا الأصل.",
working: "جارٍ التنفيذ…",
resendInvite: "إعادة إرسال الدعوة",
sendInvite: "إرسال دعوة",
editPermissions: "تحرير الأذونات",
revokeAccess: "إلغاء الوصول",
viewContact: "عرض جهة الاتصال",
viewRequests: "عرض الطلبات",
},
listSignalPills: {
riskDefaultLabel: "المخاطر",
overdueJob_one: "أمر عمل متأخر",
overdueJob_other: "أمر عمل متأخر",
complianceLabel: "الامتثال",
overdueJob_zero: "لا أوامر عمل متأخرة",
overdueJob_two: "أمرا عمل متأخران",
overdueJob_few: "أوامر عمل متأخرة",
overdueJob_many: "أمرَ عمل متأخرًا",
},
overviewQuickActions: {
defaultTitle: "إجراءات سريعة",
},
imageCarousel: {
photoPosition: "صورة {{current}} من {{total}}",
photoSingle: "صورة",
labeledPosition: "{{label}}، {{position}}",
viewFullSize: "{{label}}. عرض الحجم الكامل",
previousPhoto: "الصورة السابقة",
nextPhoto: "الصورة التالية",
goToPhoto: "الانتقال إلى الصورة {{current}} من {{total}}",
},
imageLightbox: {
defaultTitle: "صور الأصول",
closeA11y: "إغلاق",
},
conditionAccordion: {
a11yLabelExpanded: "{{title}}، موسع",
a11yLabelCollapsed: "{{title}}، مطوي",
},
impactChip: {
a11yLabel_one: "يغذي هذا الأصل أصلًا مرتبطًا واحدًا — اعرض عمله",
a11yLabel_other: "يغذي هذا الأصل {{count}} أصل مرتبط — اعرض عملها",
text_one: "يغذي أصلًا مرتبطًا واحدًا — المشكلات هنا قد تؤثر على عمله",
text_other: "يغذي {{count}} أصل مرتبط — المشكلات هنا قد تؤثر على عملها",
a11yLabel_zero: "لا يغذي هذا الأصل أي أصول مرتبطة",
a11yLabel_two: "يغذي هذا الأصل أصلين مرتبطين — اعرض عملهما",
a11yLabel_few: "يغذي هذا الأصل {{count}} أصول مرتبطة — اعرض عملها",
a11yLabel_many: "يغذي هذا الأصل {{count}} أصلًا مرتبطًا — اعرض عملها",
text_zero: "لا يغذي أصولًا مرتبطة",
text_two: "يغذي أصلين مرتبطين — المشكلات هنا قد تؤثر على عملهما",
text_few: "يغذي {{count}} أصول مرتبطة — المشكلات هنا قد تؤثر على عملها",
text_many: "يغذي {{count}} أصلًا مرتبطًا — المشكلات هنا قد تؤثر على عملها",
},
assetDetailsPanel: {
roomCounts: "أعداد الغرف",
bedrooms: "غرف النوم",
bathrooms: "الحمامات",
kitchens: "المطابخ",
livingRooms: "غرف المعيشة",
diningRooms: "غرف الطعام",
utilityRooms: "غرف المرافق",
garages: "المرائب",
parkingSpaces: "أماكن وقوف السيارات",
amenities: "وسائل الراحة",
garden: "حديقة",
driveway: "ممر السيارات",
balcony: "شرفة",
ensuite: "بحمام داخلي",
outbuilding: "البناء الخارجي",
basement: "الطابق السفلي",
loft: "علّية",
furnishing: "التأثيث",
systems: "الأنظمة",
facilityCounts: "أعداد المرافق",
units: "الوحدات",
toilets: "المراحيض",
kitchenettes: "مطابخ صغيرة",
loadingBays: "منصات التحميل",
lifts: "المصاعد",
facilityFeatures: "ميزات المنشأة",
reception: "الاستقبال",
plantRoom: "غرفة المعدات",
fireAlarm: "إنذار الحريق",
sprinklers: "رشاشات الحريق",
accessControl: "التحكم في الوصول",
shutterDoors: "أبواب مصراع",
condition: "الحالة",
capacity: "السعة",
seatingCapacity: "سعة الجلوس",
loadCapacity: "السعة التحميلية",
datesService: "التواريخ والخدمة",
year: "سنة",
yearPlaceholder: "مثال: 2024",
odometer: "عداد المسافات",
roadCompliance: "امتثال المركبة لأنظمة المرور",
capacityElectrical: "السعة والكهرباء",
voltage: "الجهد الكهربائي",
phase: "الطور",
capacityValue: "قيمة السعة",
serviceSchedule: "جدول الخدمة",
serviceIntervalDays: "الفاصل الزمني للخدمة (أيام)",
details: "التفاصيل",
coreDetails: "التفاصيل الأساسية",
propertyDetails: "تفاصيل العقار",
propertyDetailsHint: "اختر فئة العقار أولاً لفتح الأقسام ذات الصلة فقط.",
retrySavingDetails: "أعد محاولة حفظ التفاصيل",
structuredDetailsFor: "تفاصيل منظمة لهذا {{assetType}}.",
noStructuredDetails: "لم يتم تأكيد أي تفاصيل مُهيكلة بعد.",
assetProfileDetails: "تفاصيل ملف تعريف الأصل",
coreDetailsConfirmed: "تم تأكيد التفاصيل الأساسية لهذا الأصل.",
hiddenUntilPropertyChosen: "يظل عدد الغرف وتفاصيل المنشأة وحقول الذكاء الاصطناعي مخفية حتى يتم اختيار فئة العقار.",
unsavedChanges: "التغييرات غير المحفوظة...",
saving: "جارٍ الحفظ…",
saved: "تم الحفظ",
couldNotSaveChanges: "تعذر حفظ التغييرات.",
changesSaveAutomatically: "يتم حفظ التغييرات تلقائيًا.",
retry: "إعادة المحاولة",
coreFieldsFilled: "تم ملء {{completed}} من {{total}} من الحقول الأساسية",
stillMissing: "ما زال مفقودًا: {{labels}}",
applySeededSuggestions_one: "تطبيق اقتراح واحد مُعدّ مسبقًا",
applySeededSuggestions_other: "تطبيق {{count}} اقتراح مُعدّ مسبقًا",
applySeededSuggestionsZero: "تطبيق الاقتراحات المُعدّة مسبقًا",
appliedSuggestions_one: "تم تطبيق اقتراح واحد — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
appliedSuggestions_other: "تم تطبيق {{count}} اقتراح — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
noSuggestionsToFill: "تتطابق هذه التفاصيل بالفعل مع كل الاقتراحات المُعدّة مسبقًا — لا يوجد ما يُملأ.",
lifecycle: "دورة الحياة",
criticality: "الأهمية",
compliance: "الامتثال",
furnishedStatus: "حالة التأثيث",
location: "الموقع",
otherCategory: "فئة أخرى",
subtypeDetailLegacy: "تفاصيل النوع الفرعي (قديمة)",
yes: "نعم",
no: "لا",
unknown: "غير معروف",
viewQrCode: "عرض رمز QR",
hideQrCode: "إخفاء رمز QR",
applySeededSuggestions_zero: "لا اقتراحات مُعدّة مسبقًا",
applySeededSuggestions_two: "تطبيق اقتراحين مُعدّين مسبقًا",
applySeededSuggestions_few: "تطبيق {{count}} اقتراحات مُعدّة مسبقًا",
applySeededSuggestions_many: "تطبيق {{count}} اقتراحًا مُعدًّا مسبقًا",
appliedSuggestions_zero: "لم يُطبَّق أي اقتراح.",
appliedSuggestions_two: "تم تطبيق اقتراحين — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
appliedSuggestions_few: "تم تطبيق {{count}} اقتراحات — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
appliedSuggestions_many: "تم تطبيق {{count}} اقتراحًا — راجع الحقول أدناه؛ تُحفظ تلقائيًا.",
},
imageDrawModal: {
colorRed: "أحمر",
colorAmber: "كهرماني",
colorGreen: "أخضر",
colorWhite: "أبيض",
toolDraw: "رسم",
toolArrow: "سهم",
toolBox: "مربع",
toolCircle: "دائرة",
toolText: "نص",
couldNotSaveMarkupTitle: "تعذر حفظ العلامات",
couldNotSaveMarkupBody: "تمت إضافة الصورة بدون العلامات.",
clearAllMarkupTitle: "هل تريد مسح كل العلامات؟",
clearAllMarkupBody: "يؤدي هذا إلى إزالة كل علامة على الصورة.",
cancel: "إلغاء",
clear: "مسح",
cancelMarkupA11y: "إلغاء وضع العلامات",
doneA11y: "تم",
done: "تم",
markupTitle: "وضع العلامات",
labelThisPointPlaceholder: "سمِّ هذه النقطة",
markupTextA11y: "نص التعليق",
addTextA11y: "إضافة نص",
add: "إضافة",
cancelTextA11y: "إلغاء النص",
undoLastMarkA11y: "التراجع عن آخر علامة",
undo: "تراجع",
clearAllMarkupA11y: "مسح كافة العلامات",
},
qrScanner: {
enterCodeTitle: "أدخل الرمز",
enterCodeBody: "يرجى لصق أو كتابة قيمة رمز QR.",
qrCodeTitle: "رمز QR",
qrCodeValueA11y: "قيمة رمز QR",
webUnavailableMessage: "المسح بالكاميرا غير متاح على الويب. الصق قيمة رمز QR أدناه أو استخدم التطبيق على هاتفك للمسح الضوئي.",
pasteOrTypePlaceholder: "الصق أو اكتب قيمة الكود QR...",
resolveCode: "البحث بالرمز",
cancel: "إلغاء",
requestingPermission: "جارٍ طلب إذن الكاميرا...",
permissionRequiredTitle: "إذن الكاميرا مطلوب",
permissionRequiredMessage: "مطلوب الوصول إلى الكاميرا لمسح رموز QR. يرجى تمكين أذونات الكاميرا في إعدادات جهازك.",
grantPermission: "منح الإذن",
typeCodeUnderQrPlaceholder: "أو اكتب الكود المطبوع تحت QR...",
scanQrCodeTitle: "مسح رمز QR",
closeScannerA11y: "إغلاق الماسح الضوئي",
typeCodeUnderQrShortPlaceholder: "اكتب الرمز المطبوع تحت QR",
positionQrHint: "ضع كود QR داخل الإطار",
backToCameraA11y: "العودة إلى الكاميرا",
enterCodeInsteadA11y: "أدخل الرمز بدلاً من ذلك",
backToCamera: "العودة إلى الكاميرا",
cantScanEnterCode: "تتعذر قراءته؟ أدخل الرمز بدلاً من ذلك",
scanned: "تم المسح",
},
measureView: {
spokenClear: "مسح",
spokenDivide: "قسمة",
spokenMultiply: "اضرب",
spokenBackspace: "مسافة للخلف",
spokenMinus: "ناقص",
spokenPlus: "زائد",
spokenEquals: "يساوي",
spokenDecimalPoint: "العلامة العشرية",
captureReading: "التقاط القراءة",
},
dictateView: {
stopDictation: "إيقاف الإملاء الصوتي",
startDictation: "بدء الإملاء",
listening: "جارٍ الاستماع…",
stopped: "متوقف",
tapToTalk: "اضغط للتحدث",
speakNaturally: "تحدث بشكل طبيعي - سوف يقوم الذكاء الاصطناعي بتسجيل السجل الصحيح.",
transcriptPlaceholder: "سوف يظهر نصك هنا أثناء حديثك.",
clear: "مسح",
useTranscript: "استخدام النص",
},
dictateCapture: {
issueDraftLabel: "مسودة المشكلة",
issueDraftDetail: "يبدو وكأنه عيب - يستطيع Copilot تقديم مشكلة.",
noteLabel: "الملاحظة",
noteDetail: "تم التقاطها كملاحظة بسيطة مرفقة بالسياق الحالي.",
},
omniCaptureSheet: {
modePhoto: "صورة",
modePhotoHint: "التقط صورة أو اخترها. التسمية التوضيحية المقترحة تلقائيًا.",
modeDictate: "إملاء",
modeDictateHint: "تحدث عن ذلك؛ يقوم الذكاء الاصطناعي بتسجيل السجل الصحيح.",
modeScan: "مسح رمز QR",
modeScanHint: "انتقل إلى الأصل المرتبط.",
modeMeasure: "قياس",
modeMeasureHint: "التقط قراءة أو قم بإجراء عملية حسابية سريعة.",
modeNote: "الملاحظة",
modeNoteHint: "ملاحظة نصية عادية مرفقة بالسياق.",
defaultTitle: "التقاط",
backA11y: "رجوع",
closeA11y: "إغلاق",
forScope: "لـ: {{scope}}",
noteA11y: "الملاحظة",
notePlaceholder: "إضافة ملاحظة...",
saveNoteA11y: "حفظ الملاحظة",
saveNote: "حفظ الملاحظة",
},
workLocationFlag: {
defaultAssetName: "الأصل",
locationCheckWaiting: "التحقق من الموقع قيد الانتظار",
recordedAway: "تم التسجيل بعيدًا عن الأصل",
carriedOutWithDistance: "نُفِّذ هذا العمل على بُعد {{distance}} من مكان تسجيل {{name}}.",
carriedOutNoDistance: "تم تنفيذ هذا العمل بعيدًا عن مكان تسجيل {{name}}.",
pendingSuffix: " لم يرد الفريق المسؤول عن إدارة الأصل بعد.",
reviewedSuffix: " تمت المراجعة: لم يتحرك الأصل.",
},
what3wordsField: {
useSuggestion: "استخدم {{words}}",
},
assetMoveSheet: {
reasonMoved: "نُقل",
reasonMovedHint: "الأصل موجود فعليًا في مكان جديد",
reasonCorrected: "لقد كان خطأ",
reasonCorrectedHint: "الأصل لم يكن أبدًا حيث قال السجل",
title: "نقل {{assetName}}",
whatHappened: "ماذا حدث؟",
whereIsItNow: "أين هو الآن؟",
whenDidItMove: "متى نُقل؟",
today: "اليوم",
yesterday: "الأمس",
lastWeek: "الأسبوع الماضي",
overAMonthAgo: "منذ أكثر من شهر",
noteOptional: "ملاحظة (اختياري)",
notePlaceholder: "مثال: نُقل إلى غرفة المعدات في الطابق تحت القبو",
recordTheMove: "تسجيل النقل",
correctTheLocation: "قم بتصحيح الموقع",
cancel: "إلغاء",
},
locationClaimReview: {
fieldResponseAssetIsHere: "أكد الشخص الموجود في الموقع وجود الأصل",
fieldResponseAssetNotHere: "قال الشخص الموجود في الموقع إن الأصل غير موجود",
fieldResponseUnsure: "الشخص الموجود في الموقع لم يكن متأكدًا",
fieldResponseDeviceReported: "أبلغ جهاز متصل عن الأصل من هناك - ولم يتم سؤال أحد",
defaultAssetName: "هذا الأصل",
stillWhereWeThinkTitle: "هل ما زال {{name}} في مكانه الذي نعتقده؟",
unknownDistance: "مسافة غير معروفة",
betweenRecordedAndSource: "بين الموقع المسجل و{{source}}",
updateAssetLocation: "تحديث موقع الأصل",
hasNotMoved: "لا، لم يتحرك",
whyNotMovedTitle: "لماذا لم يتحرك؟",
whyNotMovedMessage: "يتم الاحتفاظ بهذا في التفتيش أو أمر العمل، حتى يتمكن الشخص الذي أبلغ عنه من رؤية ما تقرر.",
whyNotMovedPlaceholder: "مثال: الأصل لا يزال في غرفة المعدات؛ حضر المهندس إلى الموقع الخطأ",
rejectAndFlag: "رفض العمل ووضع علامة عليه",
},
locationField: {
defaultAddressLabel: "العنوان",
searchAddressPlaceholder: "ابحث عن عنوان…",
pinSavedAccurate: "تم حفظ الدبوس، بدقة نحو {{meters}} م",
pinSaved: "تم حفظ الدبوس",
level: "المستوى",
levelIndexPlaceholder: "0 = أرضي، \u{2066}-2\u{2069} = قبو 2",
levelName: "اسم المستوى",
levelNamePlaceholder: "مثال: القبو 2، السطح",
depthLabel: "العمق تحت الأرض (بالأمتار)",
depthPlaceholder: "مثال: 3.2 لخط رئيسي مدفون",
doesItMove: "هل يتحرك؟",
useCurrentLocation: "استخدام الموقع الحالي",
},
locationCheckPrompt: {
isHereTitle: "هل {{assetName}} هنا؟",
assetIsHere: "نعم، الأصل موجود هنا",
assetNotHere: "لا، الأصل موجود في مكان آخر",
unsure: "لست متأكدا",
explainWithDistance: "سُجِّل هذا العمل على بُعد {{distance}} من مكان {{assetName}} المسجَّل في الملف.",
explainNoDistance: "تم تسجيل هذا العمل بعيدًا عن مكان وجود {{assetName}} في الملف.",
reassure: "إجابتك تذهب إلى الفريق الذي يدير هذا الأصل. لا شيء يتغير حتى يؤكدوا ذلك.",
},
actionPickerHost: {
share: {
title: "مشاركة أحد الأصول",
subtitle: "اختر الأصل المراد مشاركته.",
},
report: {
title: "الإبلاغ عن مشكلة",
subtitle: "اختر الأصل للإبلاغ عن مشكلة بشأنه.",
},
meterReading: {
title: "تسجيل القراءة",
subtitle: "اختر الأصل الذي ينتمي إليه جهاز القياس.",
},
maintenancePlan: {
title: "أضف خطة صيانة",
subtitle: "اختر الأصل الذي تستهدفه الخطة.",
},
inspection: {
title: "ابدأ فحصًا",
subtitle: "اختر الأصل المراد فحصه.",
},
job: {
title: "سجّل مهمة",
subtitle: "اختر الأصل الذي تخصه المهمة.",
},
},
assetDetailScreen: {
  contactInteraction: {
    unknownName: "غير معروف",
    approvalReceived: "تم استلام الموافقة",
    reportShared: "تمت مشاركة التقرير",
  },
  lastInspectionOutcome: {
    inProgress: "الفحص قيد التنفيذ",
    completed: "اكتمل الفحص الأخير",
    failed: "لم يجتز الفحص الأخير",
  },
  kpiInfo: {
    profileA11y: "التفاصيل مكتملة بنسبة {{score}}%. يفتح التفاصيل.",
    profilePill: "التفاصيل مكتملة بنسبة {{score}}%",
    healthA11y: "الصحة التشغيلية: {{status}}",
    noSchedule: "لا يوجد شيء مجدول",
    doneCount: "مكتملة: {{n}}",
    scheduledCount: "مجدولة: {{n}}",
    overdueCount: "متأخرة: {{n}}",
    noOpenJobs: "لا توجد أعمال مفتوحة",
    openJobsBasedOn: "{{open}} من {{total}} أعمال على هذا الأصل",
    openJobsDescription: "أعمال على هذا الأصل لم يتم التحقق منها أو إلغاؤها بعد. العمل الذي ينتظر الاعتماد لا يزال محسوبًا.",
    complianceBasedOn: "المستندات المحفوظة: {{n}}",
    complianceGuidance: "اضغط على البطاقة لعرض كل مستند.",
    complianceDescription: "درجة من 0 إلى 100 للشهادات والمستندات التي يحتاجها هذا النوع من الأصول، وتنخفض كلما اقترب انتهاؤها.",
    riskEmpty: "لا يوجد فحص بعد، لذا لا يمكن حساب المخاطر.",
    riskBasedOn: "آخر فحص {{date}}",
    riskGuidance: "اضغط على البطاقة لترى كيف حُسبت الدرجة.",
    riskDescription: "احتمال حدوث مشكلة مضروبًا في مدى خطورتها، وكل منهما من 1 إلى 5 بناءً على آخر فحص وأهمية الأصل. 25 هو الحد الأقصى؛ و15 فأكثر مرتفع.",
    healthBasedOn: "{{open}} أعمال مفتوحة · {{overdue}} متأخرة · {{failed}} بنود فاشلة · آخر فحص {{last}}",
    healthEmpty: "لم يُسجَّل لهذا الأصل أي فحص أو شهادة أو عمل بعد.",
    healthGuidance: "اضغط على البطاقة لترى ما غيّر الدرجة وما يجب فعله بعد ذلك.",
    healthDescription: "الصحة التشغيلية: درجة من 0 إلى 100 مبنية على الشهادات ونتائج الفحص والأعمال المفتوحة والمتأخرة وعمر الأصل. 80 فأكثر جيد، ومن 55 إلى 79 مراقبة، وأقل من 55 ضعيف. تقييم الحالة من 1 إلى 5 في الفحوصات مقياس منفصل.",
    never: "أبدًا",
    noInspectionYet: "لا يوجد فحص بعد",
    nothingYet: "لم يُسجَّل شيء بعد",
    unavailable: "تعذّر التحميل",
  },
  approver: {
    anyoneInTeam: "أي شخص في الفريق",
    anyoneIn: "أي شخص في {{team}}",
  },
  header: {
    subtitle: "{{lifecycle}} · {{site}} · المالك {{owner}}",
    noSite: "لا يوجد موقع بعد",
  },
  blocked: {
    archivedNoJobs: "لا يمكن إنشاء أعمال جديدة للأصول المؤرشفة.",
    retiredNoJobs: "لا يمكن إنشاء أعمال جديدة للأصول الخارجة من الخدمة نهائيًا.",
    archivedNoInspections: "لا يمكن بدء فحوصات جديدة للأصول المؤرشفة.",
    retiredNoInspections: "لا يمكن بدء فحوصات جديدة للأصول الخارجة من الخدمة نهائيًا.",
    decommissionedBody: "أعده أولًا: اضغط إعادة التشغيل أعلى هذا الأصل. يبدأ ذلك فحصًا، ثم أي أعمال يكشف عنها.",
    plannedBody: "أدخله الخدمة أولًا: اضغط تشغيل أعلى هذا الأصل. يبدأ ذلك فحصًا، ثم أي أعمال يكشف عنها.",
    archivedBody: "لا يزال بإمكانك عرضه وتعديله. لإضافة فحوصات أو أعمال، ألغِ أرشفته من القائمة ⋯.",
    retiredBody: "لا يزال سجله متاحًا، لكن لا يمكنك إضافة فحوصات أو أعمال. يمكن للمالك أو المسؤول استعادته من القائمة ⋯.",
    archivedTitle: "هذا الأصل مؤرشف",
    retiredTitle: "هذا الأصل خارج الخدمة نهائيًا",
  },
  commissionCase: {
    returnStep: "تم التحقق من كل شيء. اضغط {{label}}.",
    fixStep: "أكمل وتحقق من كل عمل نتج عن الفحص. بعد ذلك يمكنك إعادته إلى الخدمة.",
    inspectStep: "التالي: اضغط ابدأ الفحص. تأتي بعده الأعمال التي يكشف عنها.",
    recommissioningTitle: "الإعادة إلى الخدمة",
    commissioningTitle: "الإدخال في الخدمة",
  },
  teamMove: {
    movedToPersonal: "نُقل إلى الشخصي. أنت فقط من يمكنه رؤيته الآن.",
    movedToTeam: "نُقل إلى {{team}}. يمكن لكل أعضاء الفريق الآن رؤيته والعمل عليه.",
  },
  knowledgeShare: {
    openLink: "أي شخص لديه الرابط",
    contact: "جهة اتصال",
    wholeLibrary: "المكتبة كاملة",
    oneItem: "عنصر واحد",
    failedBody: "تحقق من اتصالك وحاول مرة أخرى.",
    failedTitle: "لم يُنشأ الرابط",
    chooseContactBody: "اضغط اختيار جهة اتصال وحدد لمن الرابط.",
    chooseContactTitle: "اختر جهة اتصال",
    noMailBody: "تم نسخ الرابط. الصقه في رسالة بدلًا من ذلك.",
    noMailTitle: "لا يوجد تطبيق بريد",
    emailBody: "افتح هذا الرابط لقراءتها: {{url}}",
    emailSubject: "معلومات تمت مشاركتها معك",
    done: "تم",
    emailIt: "بريد إلى {{name}}",
    copiedBodyEmail: "اضغط بريد لإرساله إلى {{name}} من تطبيق البريد، أو الصقه في أي رسالة.",
    copiedBody: "الصقه في رسالة إلى {{name}}. لا يُرسل شيء حتى تفعل ذلك.",
    linkTitle: "رابط المشاركة",
    copiedTitle: "تم نسخ الرابط",
    hintItem: "اختر لمن الرابط. يمكن لأي شخص لديه الرابط فتح هذا العنصر، فأرسله إليه فقط. يمكنك إيقاف أي رابط أدناه في أي وقت.",
    hintLibrary: "اختر لمن الرابط. يمكن لأي شخص لديه الرابط فتح كل معرفة هذا الأصل، فأرسله إليه فقط. يمكنك إيقاف أي رابط أدناه في أي وقت.",
    invalidUrlBody: "أدخل عنوان الويب كاملًا بدءًا بـ https://، مثل https://example.com/manual.",
    invalidUrlTitle: "تحقق من عنوان الويب",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
  },
loadingDetails: "جارٍ تحميل تفاصيل الأصول...",
assetNotFound: "لم يتم العثور على الأصل",
loadErrorTitleRetryable: "لم نتمكن من تحميل هذا الأصل",
loadErrorTitleFinal: "لا يمكن عرض هذا الأصل",
assetOptionsA11y: "خيارات الأصول",
changeApproverA11y: "قم بتغيير من يوافق على العمل على هذا الأصل",
change: "تغيير",
createdBanner: {
title: "تم إنشاء الأصل",
subtitle: "ابدأ الفحص الموصى به، أو أبلغ عن مشكلة، أو أضف تفاصيل اختيارية.",
inspectNow: "قم بالفحص الآن",
inspectNowA11y: "قم بفحص هذا الأصل الآن",
reportIssue: "الإبلاغ عن مشكلة",
reportIssueA11y: "أبلغ عن مشكلة لهذا الأصل",
addDetails: "أضف التفاصيل",
addDetailsA11y: "أضف تفاصيل الأصول الاختيارية",
share: "مشاركة",
shareA11y: "شارك هذا الأصل مع جهة اتصال",
dismissA11y: "تجاهل",
},
capture: {
notSavedTitle: "لم يُحفظ الالتقاط",
notFoundBody: "تعذر العثور على هذا الالتقاط. يرجى التقاطها مرة أخرى.",
mismatchBody: "لا يتطابق هذا الالتقاط مع الأصل الحالي.",
photoAdded: "تمت إضافة الصورة إلى الأصل",
notesUpdated: "تم تحديث ملاحظات الأصل",
measurementAdded: "تمت إضافة القياس إلى ملاحظات الأصل",
notSupportedTitle: "الالتقاط غير مدعوم",
notSupportedBody: "يتم التعامل مع مسح رمز QR من الماسح الضوئي، ولا يُحفظ في الأصول.",
noPhotoCaptured: "لم يتم التقاط أي صورة.",
signInRequiredForPhotos: "يجب عليك تسجيل الدخول لحفظ الصور.",
noNoteCaptured: "لم يتم التقاط نص الملاحظة.",
modeNotSupported: "وضع الالتقاط هذا غير مدعوم للأصول.",
},
tryAgain: "حاول مرة أخرى.",
contactsAlerts: {
  pickerCreateLabel: "إنشاء جهة اتصال وربطها",
  pickerLinkTitle: "ربط جهة اتصال",
  pickerShareTitle: "المشاركة مع جهة اتصال",
  defaultInviterName: "زميل",
  linkedBody: "تم ربط {{name}} بهذا الأصل.",
  sharedAndInvitedBody: "تمت المشاركة مع {{name}}. أرسلنا دعوة إلى {{email}}؛ سيرى الأصل بعد قبولها.",
  sharedWithBody: "تمت المشاركة مع {{name}}. يمكنه الآن رؤية هذا الأصل في AssetWRX.",
emailRequiredTitle: "البريد الإلكتروني مطلوب",
emailRequiredBody: "قم بإضافة بريد إلكتروني على جهة الاتصال هذه قبل إرسال دعوة.",
inviteFailedTitle: "غير قادر على إرسال الدعوة",
selectRelationshipTitle: "حدد العلاقة",
selectRelationshipBody: "اختر نوع علاقة واحدًا على الأقل قبل الحفظ.",
accessSaveFailedTitle: "غير قادر على حفظ الوصول إلى جهة الاتصال",
accessUpdateFailedTitle: "غير قادر على تحديث الوصول",
resendInviteFailed: "غير قادر على إعادة إرسال الدعوة.",
inviteSent: "تم إرسال الدعوة",
inviteUpdated: "تم تحديث الدعوة",
inviteCreated: "تم إنشاء الدعوة",
inviteEmailSentBody: "تم إرسال رسالة الدعوة إلى {{email}}.",
inviteRefreshedEmailFailedBody: "تم تحديث الدعوة، لكن فشل تسليم البريد الإلكتروني. يمكنك إعادة الإرسال.",
inviteSavedEmailFailedBody: "تم حفظ الدعوة لـ {{email}}. لا يمكن إرسال البريد الإلكتروني{{errorSuffix}}.",
inviteErrorSuffix: ": {{error}}",
defaultContactName: "جهة اتصال",
savedTitle: "تم الحفظ",
sharedWithCountBody_zero: "تمت مشاركته مع {{count}} جهة اتصال. أرسل دعوات من الوصول المشترك عند الحاجة.",
sharedWithCountBody_one: "تمت مشاركته مع جهة اتصال واحدة. أرسل دعوات من الوصول المشترك عند الحاجة.",
sharedWithCountBody_two: "تمت مشاركته مع جهتَي اتصال. أرسل دعوات من الوصول المشترك عند الحاجة.",
sharedWithCountBody_few: "تمت مشاركته مع {{count}} جهات اتصال. أرسل دعوات من الوصول المشترك عند الحاجة.",
sharedWithCountBody_many: "تمت مشاركته مع {{count}} جهةَ اتصال. أرسل دعوات من الوصول المشترك عند الحاجة.",
sharedWithCountBody_other: "تمت مشاركته مع {{count}} جهة اتصال. أرسل دعوات من الوصول المشترك عند الحاجة.",
linkedCountBody_zero: "تم ربط {{count}} جهة اتصال.",
linkedCountBody_one: "تم ربط جهة اتصال واحدة.",
linkedCountBody_two: "تم ربط جهتَي اتصال.",
linkedCountBody_few: "تم ربط {{count}} جهات اتصال.",
linkedCountBody_many: "تم ربط {{count}} جهةَ اتصال.",
linkedCountBody_other: "تم ربط {{count}} جهة اتصال.",
linkContactFailed: "غير قادر على ربط جهة الاتصال بأنواع العلاقات المحددة.",
inviteRequiredTitle: "الدعوة مطلوبة",
inviteRequiredNoEmailBody: "تم حفظ الوصول، لكن جهة الاتصال هذه ليس لديها بريد إلكتروني، لذا لا يمكن إبلاغها. أضف بريدها في جهة الاتصال، ثم اضغط إرسال دعوة ضمن الوصول المشترك.",
inviteRequiredBody: "يتم حفظ الوصول المشترك. أرسل دعوة جهة اتصال الآن حتى يتمكن هذا الشخص من ربط حسابه ورؤية الأصل.",
notNow: "ليس الآن",
sendInvite: "إرسال دعوة",
inviteSentAcceptedBody: "تم إرسال دعوة إلى {{email}}. وبمجرد قبولها، سيتمكنون من الوصول إلى هذا الأصل المشترك.",
inviteCreatedDeliveryFailedBody: "تم إنشاء دعوة لـ {{email}}، لكن فشل تسليم البريد الإلكتروني. يمكنك إعادة الإرسال من الوصول المشترك.",
inviteFailedFallback: "تم حفظ المشاركة، لكن فشلت الدعوة. يرجى المحاولة مرة أخرى من جهات الاتصال.",
},
lifecycle: {
  standingA11y: "الحالة: {{label}}",
  locationCorrected: "تم تصحيح الموقع.",
  moveRecorded: "تم تسجيل النقل. يبقى المكان القديم في سجل المواقع.",
decommissioningTitle: "جارٍ الإخراج من الخدمة",
decommissioningDetail: "يخرج من الخدمة عند التحقق من أمر عمل التأمين{{jobStatusSuffix}}.",
decommissioningJobStatusSuffix: " — حالة أمر العمل: {{status}}",
startCommissioningFailedTitle: "لا يمكن بدء التشغيل",
backInService: "العودة إلى الخدمة",
returnToServiceFailedTitle: "تعذّر إعادة هذا الأصل إلى الخدمة",
openMakeSafeJob: "افتح أمر عمل التأمين",
startInspection: "ابدأ الفحص",
openInspection: "افتح الفحص",
createJobsFromFindings: "إنشاء أوامر العمل من النتائج",
waiveAndReturn: "التنازل والعودة إلى الخدمة",
putIntoService: "إدخال في الخدمة",
returnToService: "إعادة إلى الخدمة",
cancel: "إلغاء",
cancelCommissioningTitle: "هل تريد إلغاء التشغيل؟",
cancelCommissioningBody: "يتم إغلاق الحالة على أنها مهجورة. يبقى التفتيش وأية أوامر عمل كسجلات.",
keepGoing: "استمر",
cancelCommissioning: "إلغاء التشغيل",
commission: "تشغيل",
recommission: "إعادة التشغيل",
unarchived: "تم إلغاء أرشفة الأصل",
archived: "تمت أرشفة الأصل",
statusUpdateFailedTitle: "غير قادر على تحديث حالة الأصل",
onlyAdminRestoreTitle: "يمكن للمسؤول فقط استعادة أصل خارج الخدمة نهائيًا",
onlyAdminRestoreBody: "اطلب من مسؤول مساحة العمل استعادتها.",
restoreFromRetiredTitle: "استعادة من حالة خارج الخدمة نهائيًا؟",
restoreFromRetiredBody: "يُعاد فتح السجل بحالة خارج الخدمة. أعد تشغيله — بإجراء فحص ثم تنفيذ أي أوامر عمل ينتج عنها — لإعادته إلى الخدمة.",
restore: "استعادة",
restoredOutOfService: "تمت الاستعادة — خارج الخدمة حتى إعادة تشغيله",
restoreFailedTitle: "غير قادر على استعادة الأصل",
moveFailedTitle: "تعذر نقل الأصل",
moveFailedBody: "لا يمكن حفظ النقلة.",
makeSafeRaised: "تم إنشاء أمر عمل التأمين — يخرج الأصل من الخدمة عند التحقق منه",
outOfService: "خارج الخدمة",
decommissionFailedTitle: "تعذّر إخراج هذا الأصل من الخدمة",
retired: "خارج الخدمة نهائيًا",
retireFailedTitle: "تعذّر إخراج هذا الأصل من الخدمة نهائيًا",
returnWaiverTitle: "العودة إلى الخدمة مع عدم حل النتائج",
returnWaiverMessage: "اذكر سبب إمكانية عودة الأصل إلى الخدمة بدون أمر عمل لما وجده الفحص. سيُدرج هذا في الشهادة.",
returnWaiverPlaceholder: "مثال: تجميلي فقط؛ مُجدوَل للإغلاق الصيفي.",
returnToServiceConfirm: "العودة إلى الخدمة",
},
errors: {
generic: "خطأ",
updateFailed: "فشل التحديث.",
deleteAssetFailed: "فشل في حذف الأصل.",
saveDetailsFailed: "فشل في حفظ تفاصيل الأصول.",
removeAccessFailedTitle: "غير قادر على إزالة الوصول",
removeAccessBody: "هل تريد إزالة الوصول إلى مساحة العمل المشتركة لـ {{name}}؟ لن يروا بعد الآن أن هذا الأصل مشترك.",
removeAccessDefaultName: "جهة الاتصال هذه",
removeAccessTitle: "إزالة الوصول",
remove: "إزالة",
couldNotSaveDetailsTitle: "تعذر حفظ تفاصيل الأصل",
syncFailed: "فشلت المزامنة.",
},
deleteAsset: {
cannotDeleteTitle: "لا يمكن الحذف بعد",
cannotDeleteBody: "لا يزال لدى هذا الأصل عمل مفتوح:\n• فحوصات مفتوحة: {{openInspections}}\n• أوامر عمل مفتوحة: {{openJobs}}\n• جداول نشطة: {{openSchedules}}\n\nأغلق هذه العناصر أو أكملها أولًا، ثم سيصبح الحذف متاحًا.",
confirmWebTitle: "هل تريد حذف الأصل؟\n\nلا يمكن التراجع عن هذا.",
confirmTitle: "حذف الأصل",
confirmBody: "هل أنت متأكد؟ لا يمكن التراجع عن هذا الإجراء.",
cancel: "إلغاء",
delete: "حذف",
},
cancelledSectionLabel: "ملغى",
readiness: {
complianceHeadline: "الامتثال — {{posture}}",
complianceDefaultAction: "مراجعة إشارات الامتثال",
inspectionOverdue: "تفتيش متأخر",
inspectionDueOn: "الفحص المستحق {{date}}",
completeOverdueInspection: "أكمل الفحص المتأخر",
prepareAndComplete: "قم بالتحضير والإكمال في الموعد المحدد",
foundationRunInspection: "أجرِ فحصًا لبدء قياس حالة الأصل",
foundationLastInspectedAgo: "آخر فحص منذ {{months}} شهر — حدِّثه",
foundationRecentLast_zero: "{{count}} حديثة · الأخير {{date}}",
foundationRecentLast_one: "{{count}} حديثة · الأخير {{date}}",
foundationRecentLast_two: "{{count}} حديثة · الأخير {{date}}",
foundationRecentLast_few: "{{count}} حديثة · الأخير {{date}}",
foundationRecentLast_many: "{{count}} حديثة · الأخير {{date}}",
foundationRecentLast_other: "{{count}} حديثة · الأخير {{date}}",
contactsLabel: "جهات الاتصال",
contactsLinked_zero: "{{count}} مرتبط · انقر للإدارة",
contactsLinked_one: "{{count}} مرتبط · انقر للإدارة",
contactsLinked_two: "{{count}} مرتبط · انقر للإدارة",
contactsLinked_few: "{{count}} مرتبط · انقر للإدارة",
contactsLinked_many: "{{count}} مرتبط · انقر للإدارة",
contactsLinked_other: "{{count}} مرتبط · انقر للإدارة",
contactsAddRecipient: "إضافة مالك أو مستلم التقرير",
documentsLabel: "المستندات",
documentsAttached_one: "{{count}} ملف مرفق",
documentsAttached_other: "{{count}} ملف مرفق",
documentsUpload: "تحميل ملفات الامتثال والضمان",
relationshipsLabel: "العلاقات",
relationshipsLinkedReach_zero: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsLinkedReach_one: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsLinkedReach_two: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsLinkedReach_few: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsLinkedReach_many: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsLinkedReach_other: "{{count}} مرتبط · النطاق {{reach}}",
relationshipsMap: "اربط الأصول التي يعتمد عليها هذا الأصل والأصول التي تعتمد عليه",
evidenceLabel: "الدليل",
documentsAttached_zero: "لا ملفات مرفقة",
documentsAttached_two: "ملفان مرفقان",
documentsAttached_few: "{{count}} ملفات مرفقة",
documentsAttached_many: "{{count}} ملفًا مرفقًا",
},
evidenceStatus: {
loadingText: "جارٍ تحميل أدلة الصحة والامتثال والمخاطر...",
failedText: "تعذر تحميل أدلة الصحة والامتثال والمخاطر.",
loadingSub: "لن تظهر الدرجات إلا بعد توفر جميع سجلات الأصل المطلوبة.",
failedSub: "اسحب للتحديث. يتم إخفاء النتائج حتى يمكن استرجاع السجلات المفقودة.",
},
conditionAccordionTitle: "الصحة والامتثال والمخاطر (التفاصيل الكاملة)",
conditionAccordionSummary: "النتائج والعوامل الرئيسية واللوحات التفصيلية — وسّع عندما تحتاج إلى الصورة الكاملة.",
kpi: {
labelHealth: "الصحة",
labelRisk: "المخاطر",
labelCompliance: "الامتثال",
labelOpenJobs: "مهام مفتوحة",
labelRecent: "الأخيرة",
labelNextDue: "الاستحقاق التالي",
labelDocuments: "المستندات",
labelFiles: "الملفات",
labelQuotes: "عروض الأسعار",
labelLinkedJobs: "أوامر العمل المرتبطة",
},
fab: {
shareAsset: "مشاركة الأصل",
shareAssetTooltip: "اسمح لشخص ما بالإبلاغ عن المشكلات المتعلقة بهذا الأصل",
shareAssetTooltipAccessOnly: "امنح جهة اتصال حق الوصول إلى هذا الأصل",
shareAssetDescription: "امنح جهة اتصال حق الوصول إلى هذا الأصل، أو افتح مدخل QR العام، حتى تصل إليك المشكلات دون أن يحتاج المُبلِّغ إلى حساب.",
reportIssue: "الإبلاغ عن مشكلة",
reportIssueTooltip: "أبلغ عن مشكلة في هذا الأصل",
reportIssueDescription: "افتح ملخص مشكلة مرفقًا به هذا الأصل والموقع والمُبلِّغ مسبقًا.",
inspectNow: "قم بالفحص الآن",
inspectNowTooltip: "ابدأ عملية فحص لهذا الأصل",
inspectNowDescription: "التقط الحالة والقراءات والصور والتوقيعات باستخدام قائمة التحقق النشطة للأصول.",
addJob: "إضافة مهمة",
addJobTooltip: "قم برفع أمر العمل لهذا الأصل",
addJobDescription: "أرسل أمر صيانة أو إصلاح أو خدمة مجدولة. يتم تعبئة الأصل والموقع ونتائج آخر فحص مسبقًا.",
recordReading: "تسجيل قراءة",
recordReadingTooltip: "قم بتسجيل قراءة العداد لهذا الأصل",
recordReadingDescription: "أدخل الرقم الظاهر على العداد — أميال أو ساعات أو دورات. تُحتسب خطط الصيانة القائمة على الاستخدام من آخر قراءة.",
addMaintenancePlan: "إضافة خطة الصيانة",
addMaintenancePlanTooltip: "جدولة عمل متكرر",
addMaintenancePlanDescription: "خدمة أو اختبار أو فحص يتكرر — حسب التاريخ أو العداد أو أيهما يحين أولًا. وتُنشئ الخطة العمل تلقائيًا عندما يحين موعده.",
addDocument: "إضافة مستند",
addDocumentTooltip: "قم بإرفاق مستند بهذا الأصل",
addDocumentDescription: "قم بتحميل أدلة الاستخدام أو الضمانات أو الشهادات أو الرسومات أو سجلات الامتثال. تُربط تلقائيًا بهذا الأصل.",
addKnowledge: "إضافة المعرفة",
addKnowledgeTooltip: "اكتب مقالة معرفية عن هذا الأصل",
addKnowledgeDescription: "التقط المعرفة أو الإجراءات أو الملاحظات كمقالة معرفية - قابلة للبحث والمشاركة جنبًا إلى جنب مع هذا الأصل.",
moveAsset: "نقل الأصل",
moveAssetTooltip: "سجّل أن هذا الأصل أصبح في مكان جديد",
moveAssetDescription: "يوضّح سبب تغيّر موقع الأصل وتوقيته، حتى يظهر النقل الفعلي في السجل بشكل مختلف عن تصحيح الموقع.",
relateAsset: "ربط الأصول",
relateAssetTooltip: "قم بربط هذا الأصل بآخر في السجل الخاص بك",
relateAssetDescription: "إنشاء علاقات بين أصل رئيسي وأصل فرعي، أو مكوّن، أو أصل نظير. تنتشر المخاطر والنشاط عبر الأصول المرتبطة.",
contacts: "جهات الاتصال",
createContact: "إنشاء جهة اتصال",
viewContactsTooltip: "عرض جهات الاتصال المرتبطة بهذا الأصل",
addContactTooltip: "أضف جهة اتصال مرتبطة بهذا الأصل",
contactsLinkedDescription: "المالكون والمشغلون والفنيون وأصحاب المصلحة المرتبطون بهذا الأصل.",
addContactDescription: "قم بتسجيل المالك أو المشغل أو الفني أو المقاول أو صاحب المصلحة لهذا الأصل.",
addContact: "إضافة جهة اتصال",
addContactTooltip2: "ربط جهة اتصال بهذا الأصل",
conditionReport: "Asset 360",
conditionReportTooltip: "Asset 360: تقرير يُكتب للقارئ الذي تختاره. يستهلك رصيدًا.",
conditionReportDescription: "ملخص تم إنشاؤه يغطي اتجاهات الحالة والأخطاء المتكررة والتكلفة حتى الآن وحالة الامتثال والإجراءات التالية الموصى بها.",
guideMe: "أرشدني",
guideMeTooltip: "قم بتوجيهي خلال مهمة تتعلق بهذا الأصل",
guideMeDescription: "إرشادات خطوة بخطوة: جدولة عمليات الفحص المتكررة، وإعداد خطة الصيانة، وتسجيل القراءة، وإضافة مستند أو معرفة، ونقلها، والمزيد.",
},
guide: {
proactiveLabel: "جدولة الفحوصات المتكررة",
proactiveHint: "فحص يتكرر، ليُكتشف التآكل قبل أن يتعطّل الأصل.",
maintenancePlanLabel: "قم بإعداد خطة الصيانة",
maintenancePlanHint: "عمل يتكرر حسب التاريخ أو العداد أو أيهما يحين أولًا.",
meterReadingLabel: "تسجيل قراءة عداد",
meterReadingHint: "أميال أو ساعات أو دورات، لذا تظل الخطط التي يتم احتسابها حسب الاستخدام في الوقت المحدد.",
raiseRequestLabel: "الإبلاغ عن مشكلة",
raiseRequestHint: "سجل مشكلة واختر ما يجب أن يحدث بعد ذلك.",
addDocumentLabel: "إضافة مستند",
addDocumentHint: "الشهادات والضمانات والأدلة مع تذكير بانتهاء الصلاحية.",
knowledgeLabel: "إضافة معرفة",
knowledgeHint: "إرشادات أو أسئلة وأجوبة أو ملاحظة يمكن لفريقك العثور عليها لاحقًا.",
moveLabel: "تسجيل نقل",
moveHint: "أين هو الآن وهل تم نقله أو تسجيله بشكل خاطئ.",
teamLabel: "انقله إلى فريق",
teamHint: "حتى يتمكن كل فرد في الفريق من العمل عليه.",
relateLabel: "ربط الأصول ذات الصلة",
relateHint: "أصل رئيسي أو جزء أو شيء يعتمد عليه.",
publicIntakeLabel: "اسمح لأي شخص بالإبلاغ عن طريق QR",
publicIntakeHint: "البلاغات العامة: أبلغ عن مشكلة بمسح الرمز ضوئيًا، دون تسجيل الدخول.",
aiReportLabel: "إعداد تقرير Asset 360",
aiReportHint: "يكتبه الذكاء الاصطناعي من كل ما هو معروف عن هذا الأصل، للقارئ الذي تختاره. يُستهلك الرصيد فقط بعد كتابته.",
decommissionLabel: "إخراجه من الخدمة",
decommissionHint: "أخرجه من الخدمة مع ذكر السبب، ومع أمر عمل لتأمينه إذا لزم الأمر.",
commissionLabelPlanned: "ضعه في الخدمة",
commissionLabelOther: "قم بإعادته إلى الخدمة",
commissionHint: "فحص التشغيل، وأوامر العمل مما يجده، ثم العودة إلى الخدمة.",
retireLabel: "أخرجه من الخدمة نهائيًا",
retireHint: "أغلق السجل نهائيًا، مع توثيق طريقة التخلص منه.",
},
copilot: {
openRequests: "الطلبات المفتوحة",
openInspections: "التفتيشات المفتوحة",
openJobs: "مهام مفتوحة",
reviewOpenWork: "مراجعة العمل المفتوح",
reviewAsset: "مراجعة الأصل",
suggestNextSteps: "اقترح الخطوات التالية",
automateRenewalWork: "أتمتة أعمال التجديد",
},
overflow: {
archive: "أرشفة",
unarchive: "إلغاء الأرشفة",
changeStatus: "تغيير الحالة",
decommission: "إخراج من الخدمة",
restoreFromRetired: "استعادة من حالة خارج الخدمة نهائيًا",
retireAsset: "إخراج الأصل من الخدمة نهائيًا",
delete: "حذف",
deleteHelpText: "لا يتوفر الحذف إلا بعد إغلاق/إكمال كافة عمليات الفحص وأوامر العمل والجداول الزمنية.",
},
refineWork: {
title: "تصفية العمل",
status: "الحالة",
all: "الكل",
scheduled: "مُجدوَل",
active: "نشط",
completed: "مكتمل",
},
sections: {
esg: "ESG",
overview: "نظرة عامة",
details: "التفاصيل",
maintenance: "الصيانة",
work: "العمل",
reports: "التقارير",
documents: "المستندات",
relationships: "العلاقات",
knowledge: "قاعدة المعرفة",
activity: "النشاط",
health: "الصحة",
particulars: "المواصفات",
contacts: "جهات الاتصال",
linkedAssets: "الأصول المرتبطة",
labelWithCount: "{{label}}، {{count}}",
articles: "المقالات",
},
},
  advancedReport: {
    shareFailedTitle: "تعذّر حفظ التقرير",
    shareGenerated: "كتبه الذكاء الاصطناعي في {{date}}. راجعه قبل الاعتماد عليه.",
    shareTitle: "تقرير الأصل: {{name}}",
    pdfDocType: "تقرير الأصل",
    insightTitle: "ملخص تقرير الأصل",
    heroSub: "يكتب الذكاء الاصطناعي تقريرًا من فحوصات هذا الأصل ومهامه ومستنداته ومخاطره وسجل صيانته.",
    heroTitle: "تقرير الأصل",
    fallbackTitle: "تقرير الأصل",
    metaKind: "تقرير بالذكاء الاصطناعي",
    summaryPlaceholder: "اضغط إنشاء التقرير لرؤية مخاطر هذا الأصل وحالته وامتثاله وما يجب فعله بعد ذلك.",
    actionGenerate: "أنشئ تقرير الأصل.",
    generateFailedTitle: "لم يُنشأ تقرير الأصل",
    analysisHistory: "السجل",
    sourceGenerated: "كتبه الذكاء الاصطناعي",
    sourceSetup: "لم يُنشأ بعد",
  },
  createForm: {
    checkout: {
      syncingBody: "تمت عملية الدفع. انتظر لحظة، ثم اضغط إنشاء الأصل مرة أخرى.",
      syncingTitle: "خطتك جاهزة تقريبًا",
      cancelledBody: "ما زالت بيانات الأصل هنا. اضغط إنشاء الأصل عندما تكون جاهزًا.",
      notStartedTitle: "لم تبدأ الخطة",
      cancelledTitle: "تم إلغاء الدفع",
      openFailedBody: "تحقق من اتصالك وحاول مرة أخرى.",
      openFailedTitle: "تعذّر فتح صفحة الدفع",
    },
    save: {
      saveWithoutPhotos: "إنشاء بدون صور",
      cancel: "إلغاء",
      photoUploadFailedBody: "هل تريد إنشاء الأصل بدون صور؟ يمكنك إضافتها لاحقًا عبر تعديل.",
      photoUploadFailedTitle: "تعذّر رفع الصور",
      photosFailedBody: "تعذّر رفع الصور. افتح الأصل واضغط تعديل لإضافتها.",
      photosFailedTitle: "تم إنشاء الأصل بدون صور",
      duplicateDecisionBody: "لم يتم حفظ اختيارك بشأن التكرار المحتمل. يمكنك ربطهما لاحقًا من الأصل.",
      duplicateDecisionTitle: "تم إنشاء الأصل",
      partialRelBody: "روابط مع أصول أخرى لم تُحفظ: {{n}}. أضفها مرة أخرى من قسم العلاقات في الأصل.",
      partialRelTitle: "تم إنشاء الأصل، ولم تُحفظ بعض الروابط",
      qrNotLinkedBody: "افتح الأصل واربط الملصق من قسم QR.",
      qrNotLinkedTitle: "تم إنشاء الأصل، ولم يتم ربط ملصق QR",
      failedBody: "تحقق من اتصالك واضغط إنشاء الأصل مرة أخرى. ما زالت بياناتك هنا.",
      failedTitle: "تعذّر إنشاء الأصل",
      nameRequiredBody: "أعطِ الأصل اسمًا، ثم اضغط إنشاء الأصل.",
      nameRequiredTitle: "اكتب اسمًا",
      signInBody: "سجّل الدخول مجددًا، ثم اضغط إنشاء الأصل.",
      signInTitle: "سجّل الدخول مجددًا",
    },
    duplicates: {
      failedBody: "تحقق من اتصالك وحاول مرة أخرى.",
      failedTitle: "تعذّر التحقق من التكرارات",
      foundTitle: "قد يكون هذا هو الأصل نفسه",
      noneBody: "لا يوجد شيء آخر يطابق هذا الاسم أو المعرّف.",
      noneTitle: "لم يتم العثور على تكرارات",
      needNameBody: "اكتب اسم الأصل، ثم تحقق من التكرارات.",
      needNameTitle: "اكتب اسمًا أولًا",
    },
    idHint: "الرقم الموجود على لوحته أو ملصقه. يتيح لك العثور على الأصل بمسحه.",
    useIdFromPhoto: "استخدام \"{{id}}\" كمعرّف أو رقم تسلسلي",
    readPlateTitle: "قراءة اللوحة",
    externalIdOptional: "{{label}} (اختياري)",
    unnamed: "أصل بلا اسم",
    dictation: {
      listening: "جارٍ الاستماع…",
      heard: "سُمِع: {{text}}",
      finishing: "جارٍ الإنهاء…",
      inserting: "جارٍ إضافة ما قلته…",
      stopA11y: "إيقاف الإملاء",
      dictateA11y: "إملاء الاسم",
      stop: "إيقاف",
      dictate: "إملاء",
    },
    footer: {
      creating: "جارٍ الإنشاء…",
      create: "إنشاء الأصل",
      needName: "اكتب اسمًا للبدء",
      needsPlan: "يحتاج الأصل التالي إلى خطة مدفوعة",
      needsPlanHint: "يُحفظ ما أدخلته أثناء اختيارك.",
      ready: "جاهز للإنشاء",
    },
    sectionWhy: {
      details: "أضف الصانع والطراز ومدى أهميته. يمكنك القيام بذلك لاحقًا.",
      identify: "أضف صورة والرقم التسلسلي أو الباركود ليمكن مسحه في الموقع.",
      location: "أضف الموقع أو العنوان حتى يتمكن الآخرون من العثور عليه.",
      basics: "سمِّه واختر نوعًا. هذا كل ما تحتاجه لإنشائه.",
    },
    location: {
      locationOptional: "الموقع (اختياري)",
      propertyAddress: "عنوان العقار",
      siteSelected: "الموقع · {{name}}",
      siteLabel: "الموقع",
      noSiteBody: "لا يوجد موقع قريب منك. اختر موقعًا من القائمة، أو اتركه فارغًا.",
      noSiteTitle: "لا يوجد موقع قريب",
      noAddressBody: "وجدنا موقعك لكن ليس عنوان الشارع. اكتب العنوان بدلًا من ذلك.",
      noAddressTitle: "لم يتم العثور على عنوان",
    },
    photos: {
      summaryCount: "{{used}} من {{max}}",
      countFull: "{{max}} من {{max}}. هذا هو الحد الأقصى.",
      countMore: "{{used}} من {{max}}. يمكنك إضافة {{left}} أخرى.",
      galleryA11y: "الاختيار من صورك. تم استخدام {{used}} من {{max}}.",
      cameraA11y: "التقاط صورة. تم استخدام {{used}} من {{max}}.",
      mainFullA11y: "الصورة الرئيسية. تمت إضافة {{max}} من {{max}} صور.",
      mainA11y: "الصورة الرئيسية. تمت إضافة {{used}} من {{max}}. اضغط لإضافة أخرى.",
      addA11y: "إضافة صور، حتى {{max}}",
      cameraBody: "اسمح لـ AssetWRX باستخدام الكاميرا من إعدادات الهاتف، ثم حاول مرة أخرى.",
      libraryBody: "اسمح لـ AssetWRX باستخدام صورك من إعدادات الهاتف، ثم حاول مرة أخرى.",
      permissionTitle: "السماح بالوصول",
      limitBody: "يمكنك إضافة ما يصل إلى {{max}} صور.",
      limitTitle: "تم بلوغ الحد الأقصى للصور",
    },
    suggestion: {
      useA11y: "استخدام {{label}} كنوع",
      dismiss: "لا، شكرًا",
      use: "استخدم هذا",
      fromPhoto: "من الصورة، يبدو أنه: {{label}}",
      looksLike: "يبدو أنه: {{label}}",
    },
    photoIdentify: {
      noMatchBody: "لم نتمكن من معرفة ما هو من الصورة. جرّب صورة أوضح، أو اختر النوع بنفسك.",
      noMatchTitle: "لم يتم العثور على تطابق",
      noCreditsBody: "لم يتبقَّ رصيد ذكاء اصطناعي في مساحة العمل. اختر النوع بنفسك.",
      failedBody: "حاول مرة أخرى، أو اختر النوع بنفسك.",
      failedTitle: "تعذّرت قراءة الصورة",
      a11y: "تحديد نوع الأصل من الصورة",
      busy: "جارٍ فحص الصورة…",
      button: "تحديد النوع من الصورة",
    },
    leaveGuard: {
      keep: "متابعة التعديل",
      leave: "مغادرة",
      message: "لم يتم حفظ الأصل الجديد بعد. هل تريد المغادرة وفقدانه؟",
    },
    namePlaceholder: {
      other: "مثال: إضاءة المسرح",
      equipment: "مثال: الغلاية 3",
      property: "مثال: 14 شارع البلوط",
      car: "مثال: تويوتا كامري 2024",
    },
    typeDesc: {
      other: "كل ما عدا ذلك",
      equipment: "الآلات والأدوات",
      property: "المباني والأراضي",
      car: "المركبات والأساطيل",
    },
  },
  lifecycleBanner: {
    plannedBody: "اضغط تشغيل لإدخاله الخدمة: فحص أولًا، ثم أي أعمال يكشف عنها.",
    decommissionedBody: "جداوله متوقفة مؤقتًا. اضغط إعادة التشغيل لإعادته إلى الخدمة.",
    archivedBody: "لا يزال بإمكانك عرضه وتعديله. لإضافة فحوصات أو أعمال، ألغِ أرشفته من القائمة ⋯.",
    retiredBody: "لا يزال سجله متاحًا للقراءة، لكنه لا يقبل فحوصات أو أعمالًا جديدة.",
    since: "منذ {{date}}",
  },
  shareReview: {
    rights: {
      view: "يمكنه عرض هذا الأصل",
      viewBody: "يراه في حسابه الخاص.",
      workBody: "يبلّغ عن المشكلات ويتابعها حتى إنجازها.",
      jobs: "عرض الأعمال",
      jobsBody: "الأعمال على هذا الأصل ومدى تقدمها.",
      inspections: "عرض الفحوصات",
      inspectionsBody: "نتائج الفحص لهذا الأصل.",
      documents: "فتح المستندات",
      documentsBody: "تبقى المستندات خاصة حتى تفعّل هذا.",
    },
    confirmLink: "ربط جهة الاتصال",
    confirmShare: "مشاركة",
    selectContact: "اختر جهة اتصال أولًا",
    batchHint: "جهات الاتصال المحددة: {{n}}. ينطبق الوصول أدناه عليهم جميعًا.",
  },
  editForm: {
    photoCountNone: "0 من {{max}} صور. كلها اختيارية.",
    photosHintA11y: "اختياري. حتى {{max}} صور.",
    saveFailedBody: "تحقق من اتصالك واضغط حفظ مرة أخرى. ما زالت تغييراتك هنا.",
    saveFailedTitle: "تعذّر حفظ تغييراتك",
    saved: "تم حفظ التغييرات.",
    partialRelTitle: "تم حفظ التغييرات، ولم تُحفظ بعض الروابط",
    uploadFailedBody: "تحقق من اتصالك واضغط حفظ مرة أخرى. ما زالت تغييراتك هنا.",
    signInBody: "سجّل الدخول مجددًا، ثم اضغط حفظ.",
    nameRequiredBody: "أعطِ الأصل اسمًا، ثم اضغط حفظ.",
    linkFailedTitle: "تعذّر تعليم التكرار",
    linkedBody: "يظهر الرابط الآن في الأصلين، لتتمكن من مراجعتهما لاحقًا.",
    linkedTitle: "تم التعليم كتكرار محتمل",
    openExisting: "فتح الأصل الآخر",
    improve: "تحسين بالذكاء الاصطناعي",
    improving: "جارٍ التحسين…",
    improveRationale: "اقرأ الملاحظات الجديدة، ثم اضغط استخدام للاحتفاظ بها.",
    improveFailedBody: "حاول مرة أخرى، أو احتفظ بكلماتك.",
    improveFailedTitle: "تعذّر تحسين الوصف",
    improveNeedsDraftBody: "اكتب أو أملِ وصفًا قصيرًا، ثم اضغط تحسين بالذكاء الاصطناعي.",
    improveNeedsDraftTitle: "اكتب بضع كلمات أولًا",
    improvedTitle: "ملاحظات الأصل المحسّنة",
    notFound: "لم يتم العثور على هذا الأصل. ربما حُذف أو ليس لديك صلاحية الوصول إليه.",
    loadFailed: "تعذّر تحميل هذا الأصل. تحقق من اتصالك واضغط إعادة المحاولة.",
  },
  sharedView: {
    facts: {
      nextVisit: "الزيارة القادمة: {{date}}",
      jobs: "الأعمال: {{n}}",
    },
    requests: {
      title: "طلباتك",
      you: "أنت: {{text}}",
      photo: "صورة",
      unread: "رد جديد",
    },
    thread: {
      title: "الطلب",
      loading: "جارٍ فتح الطلب…",
      loadFailedTitle: "تعذّر فتح هذا الطلب",
      loadFailed: "تحقق من اتصالك ثم اضغط إعادة المحاولة.",
      showProgress: "إظهار التقدم وما يمكنك فعله",
      hideProgress: "إخفاء التقدم",
    },
    records: {
      documents: "المستندات",
      jobs: "أوامر العمل",
      inspections: "الفحوصات",
      no_documents: "لا توجد مستندات لهذا الأصل بعد.",
      no_jobs: "لا توجد أوامر عمل لهذا الأصل بعد.",
      no_inspections: "لا توجد فحوصات لهذا الأصل بعد.",
      loadFailed: "تعذّر التحميل. اسحب للأسفل لإعادة المحاولة.",
      openDocument: "فتح {{title}}",
      expires: "ينتهي في {{date}}",
      due: "مستحق في {{date}}",
      done: "اكتمل في {{date}}",
      inspection: "فحص",
      inspectionNumbered: "فحص {{number}}",
      issues: "المشكلات: {{n}}",
    },
    raiseRequest: "الإبلاغ عن مشكلة",
    sharedWithYou: "تمت مشاركته معك",
    kpiRelatedJobs: "الأعمال المرتبطة",
    none: "لا يوجد",
    kpiNextInspection: "الفحص التالي",
    kpiStatus: "الحالة",
    permDocuments: "المستندات",
    permInspections: "الفحوصات",
    permJobs: "الأعمال",
    accept: "قبول",
    working: "جارٍ التنفيذ…",
    invitation: "دعوة",
    thisAsset: "هذا الأصل",
    tryAgain: "إعادة المحاولة",
    checking: "جارٍ التحقق…",
    sharedReadOnly: "مشترك · للقراءة فقط",
    readOnly: "للقراءة فقط",
    refreshFailedBody: "تحقق من اتصالك واضغط إعادة المحاولة.",
    refreshFailedTitle: "تعذّر التحديث",
    stillNoAccessBody: "حسابك غير مرتبط بهذه المشاركة بعد. اقبل الدعوة من بريدك الإلكتروني، أو اطلب ممن شاركها إعادة مشاركتها مع بريدك الإلكتروني.",
    stillNoAccessTitle: "لا يزال الوصول غير متاح",
    sharedAccess: "تمت مشاركته معك",
    pendingAccess: "بانتظار قبولك",
    job: "عمل",
    linkedAsset: "أصل مرتبط",
    theirWorkspace: "مساحة عمله",
    aTeamMember: "أحد أعضاء الفريق",
    checkFailed: "تعذّر التحقق من وصولك إلى هذا الأصل. تحقق من اتصالك واضغط إعادة المحاولة.",
    notScheduled: "غير مجدول",
    accessTimedOut: "استغرق التحقق من وصولك وقتًا طويلًا. تحقق من اتصالك واضغط إعادة المحاولة.",
  },
retireConfirmWord: "إنهاء",
knowledgeKind: {
  updatedAgo: "حُدّث {{when}}",
  someone: "أحد أعضاء الفريق",
  pinnedPrefix: "مثبّت",
  link: "رابط خارجي",
  howto: "طريقة",
  note: "ملاحظة",
  faq: "الأسئلة الشائعة",
  file: "ملف",
},
knowledgeTab: {
  searchPlaceholder: "ابحث في المعرفة…",
  uploadDocument: "رفع مستند",
  noMatchingArticles: "لا توجد مقالات مطابقة",
  noArticlesYet: "لا توجد مقالات بعد",
  noMatchHint: "لا توجد مقالات تطابق البحث أو عوامل التصفية الحالية.",
  emptyManageHint: "أضف أدلة إرشادية أو روابط أو أسئلة شائعة أو ملفات ليجدها فريقك أثناء العمل.",
  emptyReadHint: "لا شيء يطابق بحثك، أو لم يُنشر شيء بعد.",
  loadErrorWithReason: "{{error}}. تحقق من اتصالك وحاول مرة أخرى.",
  loadErrorHint: "تحقق من اتصالك وحاول مرة أخرى.",
  newArticle: "مقالة جديدة",
  editArticle: "تعديل المقالة",
  exactMatch: "تطابق تام",
  anyMatchCommaSeparated: "أي تطابق، مفصولة بفواصل",
  commaSeparated: "مفصولة بفواصل",
  polishedDescription: "وصف مُحسَّن",
  polishedContent: "محتوى مُحسَّن",
  polishFailedTitle: "تعذّر التحسين",
  polishUnavailable: "تعذّر التحسين الآن.",
  polishReview: "راجع النص المُحسَّن قبل تطبيقه.",
  polishDescriptionFailed: "تعذّر تحسين الوصف.",
  polishContentFailed: "تعذّر تحسين المحتوى.",
  titleRequiredTitle: "العنوان مطلوب",
  titleRequiredBody: "يرجى إدخال عنوان.",
  errorTitle: "خطأ",
  saveFailed: "تعذّر الحفظ",
  uploadFailedTitle: "تعذّر الرفع",
  uploadFailedBody: "تعذّر رفع الملف",
  deleteTitle: "حذف المقالة",
  deleteBody: "هل تريد إزالة «{{title}}»؟",
  deleteFailed: "تعذّر الحذف",
  cancel: "إلغاء",
  delete: "حذف",
},
needsAttention: {
  requestsAwaitingApproval_zero: "لا طلبات بانتظار الموافقة",
  requestsAwaitingApproval_one: "طلب واحد بانتظار الموافقة",
  requestsAwaitingApproval_two: "طلبان بانتظار الموافقة",
  requestsAwaitingApproval_few: "{{count}} طلبات بانتظار الموافقة",
  requestsAwaitingApproval_many: "{{count}} طلبًا بانتظار الموافقة",
  requestsAwaitingApproval_other: "{{count}} طلب بانتظار الموافقة",
  requestsAwaitingWork_zero: "لا طلبات معتمدة تحتاج إلى عمل",
  requestsAwaitingWork_one: "طلب معتمد واحد يحتاج إلى عمل",
  requestsAwaitingWork_two: "طلبان معتمدان يحتاجان إلى عمل",
  requestsAwaitingWork_few: "{{count}} طلبات معتمدة تحتاج إلى عمل",
  requestsAwaitingWork_many: "{{count}} طلبًا معتمدًا يحتاج إلى عمل",
  requestsAwaitingWork_other: "{{count}} طلب معتمد يحتاج إلى عمل",
  overdueJobs_zero: "لا مهام متأخرة",
  overdueJobs_one: "مهمة متأخرة واحدة",
  overdueJobs_two: "مهمتان متأخرتان",
  overdueJobs_few: "{{count}} مهام متأخرة",
  overdueJobs_many: "{{count}} مهمةً متأخرة",
  overdueJobs_other: "{{count}} مهمة متأخرة",
  inspectionsAwaitingApproval_zero: "لا فحوصات بانتظار الموافقة",
  inspectionsAwaitingApproval_one: "فحص واحد بانتظار الموافقة",
  inspectionsAwaitingApproval_two: "فحصان بانتظار الموافقة",
  inspectionsAwaitingApproval_few: "{{count}} فحوصات بانتظار الموافقة",
  inspectionsAwaitingApproval_many: "{{count}} فحصًا بانتظار الموافقة",
  inspectionsAwaitingApproval_other: "{{count}} فحص بانتظار الموافقة",
  expiredDocuments_zero: "لا مستندات منتهية الصلاحية",
  expiredDocuments_one: "مستند واحد منتهي الصلاحية",
  expiredDocuments_two: "مستندان منتهيا الصلاحية",
  expiredDocuments_few: "{{count}} مستندات منتهية الصلاحية",
  expiredDocuments_many: "{{count}} مستندًا منتهي الصلاحية",
  expiredDocuments_other: "{{count}} مستند منتهي الصلاحية",
  expiringSoonDocuments_zero: "لا مستندات تنتهي صلاحيتها قريبًا",
  expiringSoonDocuments_one: "مستند واحد تنتهي صلاحيته قريبًا",
  expiringSoonDocuments_two: "مستندان تنتهي صلاحيتهما قريبًا",
  expiringSoonDocuments_few: "{{count}} مستندات تنتهي صلاحيتها قريبًا",
  expiringSoonDocuments_many: "{{count}} مستندًا تنتهي صلاحيتها قريبًا",
  expiringSoonDocuments_other: "{{count}} مستند تنتهي صلاحيته قريبًا",
  overdueSchedules_zero: "لا فحوصات مجدولة متأخرة",
  overdueSchedules_one: "فحص مجدول واحد متأخر",
  overdueSchedules_two: "فحصان مجدولان متأخران",
  overdueSchedules_few: "{{count}} فحوصات مجدولة متأخرة",
  overdueSchedules_many: "{{count}} فحصًا مجدولًا متأخرًا",
  overdueSchedules_other: "{{count}} فحص مجدول متأخر",
  unresolvedFindings_zero: "لا نتائج فحص غير محلولة",
  unresolvedFindings_one: "نتيجة فحص واحدة غير محلولة",
  unresolvedFindings_two: "نتيجتا فحص غير محلولتين",
  unresolvedFindings_few: "{{count}} نتائج فحص غير محلولة",
  unresolvedFindings_many: "{{count}} نتيجةَ فحص غير محلولة",
  unresolvedFindings_other: "{{count}} نتيجة فحص غير محلولة",
  pendingApprovals_zero: "لا تقارير مشتركة بانتظار الاعتماد",
  pendingApprovals_one: "تقرير مشترك واحد بانتظار الاعتماد",
  pendingApprovals_two: "تقريران مشتركان بانتظار الاعتماد",
  pendingApprovals_few: "{{count}} تقارير مشتركة بانتظار الاعتماد",
  pendingApprovals_many: "{{count}} تقريرًا مشتركًا بانتظار الاعتماد",
  pendingApprovals_other: "{{count}} تقرير مشترك بانتظار الاعتماد",
  openHighUrgencyJobs_zero: "لا مهام مفتوحة عالية الأولوية",
  openHighUrgencyJobs_one: "مهمة مفتوحة واحدة عالية الأولوية",
  openHighUrgencyJobs_two: "مهمتان مفتوحتان عاليتا الأولوية",
  openHighUrgencyJobs_few: "{{count}} مهام مفتوحة عالية الأولوية",
  openHighUrgencyJobs_many: "{{count}} مهمةً مفتوحة عالية الأولوية",
  openHighUrgencyJobs_other: "{{count}} مهمة مفتوحة عالية الأولوية",
  failedInspections_zero: "لا فحوصات رصدت إخفاقات",
  failedInspections_one: "رصد فحص حديث إخفاقات",
  failedInspections_two: "فحصان رصدا إخفاقات",
  failedInspections_few: "{{count}} فحوصات رصدت إخفاقات",
  failedInspections_many: "{{count}} فحصًا رصد إخفاقات",
  failedInspections_other: "{{count}} فحص رصد إخفاقات",
  detail: {
    approveOrDecline: "وافق أو ارفض",
    createJobOrInspection: "أنشئ مهمة أو فحصًا",
    progressOrReschedule: "تابع العمل أو أعد جدولته",
    reviewAndApprove: "راجع ووافق",
    renewOrReplace: "جدّد الملفات أو استبدلها",
    planRenewal: "خطط للتجديد",
  },
},
conditionTrend: {
  loading: "جارٍ تحميل الفحوصات المكتملة وتقييمات الحالة…",
  loadFailed: "تعذّر تحميل الفحوصات المكتملة وتقييمات الحالة. اسحب للتحديث وحاول مرة أخرى.",
  emptyNoInspections: "يظهر اتجاه الحالة بعد أول فحص مُقيَّم.",
  emptyUnrated_zero: "لا توجد فحوصات مكتملة، لذا لا يوجد اتجاه بعد.",
  emptyUnrated_one: "فحص مكتمل واحد بلا تقييم حالة من 1 إلى 5، لذا لا يوجد اتجاه بعد.",
  emptyUnrated_two: "فحصان مكتملان بلا تقييم حالة من 1 إلى 5، لذا لا يوجد اتجاه بعد.",
  emptyUnrated_few: "{{count}} فحوصات مكتملة بلا تقييم حالة من 1 إلى 5، لذا لا يوجد اتجاه بعد.",
  emptyUnrated_many: "{{count}} فحصًا مكتملًا بلا تقييم حالة من 1 إلى 5، لذا لا يوجد اتجاه بعد.",
  emptyUnrated_other: "{{count}} فحص مكتمل بلا تقييم حالة من 1 إلى 5، لذا لا يوجد اتجاه بعد.",
  band: { good: "جيدة", fair: "مقبولة", poor: "ضعيفة" },
  latest: "{{percent}}% · {{band}}",
  readingsA11y: "قراءات الحالة، من الأقدم إلى الأحدث: {{readings}}",
  readingA11y: "{{percent}} بالمئة {{band}}",
  ratedInspections_zero: "لا فحوصات مُقيَّمة",
  ratedInspections_one: "فحص مُقيَّم واحد",
  ratedInspections_two: "فحصان مُقيَّمان",
  ratedInspections_few: "{{count}} فحوصات مُقيَّمة",
  ratedInspections_many: "{{count}} فحصًا مُقيَّمًا",
  ratedInspections_other: "{{count}} فحص مُقيَّم",
  oneRated: "فحص مُقيَّم واحد · فحص آخر يُظهر الاتجاه",
  down_zero: "انخفضت من {{first}}% إلى {{last}}%.",
  down_one: "انخفضت من {{first}}% إلى {{last}}% في فحص واحد.",
  down_two: "انخفضت من {{first}}% إلى {{last}}% عبر فحصين.",
  down_few: "انخفضت من {{first}}% إلى {{last}}% عبر {{count}} فحوصات.",
  down_many: "انخفضت من {{first}}% إلى {{last}}% عبر {{count}} فحصًا.",
  down_other: "انخفضت من {{first}}% إلى {{last}}% عبر {{count}} فحص.",
  steady_zero: "ثابتة عند {{last}}%.",
  steady_one: "ثابتة عند {{last}}% في فحص واحد.",
  steady_two: "ثابتة عند {{last}}% عبر فحصين.",
  steady_few: "ثابتة عند {{last}}% عبر {{count}} فحوصات.",
  steady_many: "ثابتة عند {{last}}% عبر {{count}} فحصًا.",
  steady_other: "ثابتة عند {{last}}% عبر {{count}} فحص.",
  up_zero: "ارتفعت من {{first}}% إلى {{last}}%.",
  up_one: "ارتفعت من {{first}}% إلى {{last}}% في فحص واحد.",
  up_two: "ارتفعت من {{first}}% إلى {{last}}% عبر فحصين.",
  up_few: "ارتفعت من {{first}}% إلى {{last}}% عبر {{count}} فحوصات.",
  up_many: "ارتفعت من {{first}}% إلى {{last}}% عبر {{count}} فحصًا.",
  up_other: "ارتفعت من {{first}}% إلى {{last}}% عبر {{count}} فحص.",
},
intelligenceCard: {
  state: {
    stable: "مستقرة",
    watch: "مراقبة",
    deteriorating: "تتدهور",
    action_recommended: "يُوصى بإجراء",
    critical: "حرجة",
  },
  strength: {
    early_signal: "إشارة مبكرة",
    moderate_evidence: "أدلة متوسطة",
    strong_evidence: "أدلة قوية",
  },
  conditionScore: "الحالة {{score}}/100 · {{strength}}",
  dataQuality: "جودة البيانات: {{warning}}",
  suggestedBy: "مقترح قبل {{date}}",
  recommendation: {
    inspect_sooner: "افحص قبل الصيانة المخطط لها",
    maintenance_sooner: "قدّم موعد الصيانة المخطط لها",
    review_interval: "راجع الفترة بين أعمال الصيانة",
    raise_follow_up: "أنشئ عملًا للمتابعة",
    monitor: "سجّل قراءة عداد لتبقى الخطة دقيقة",
  },
  recordFailedTitle: "تعذّر تسجيل ذلك",
  dismissFailedTitle: "تعذّر تجاهل ذلك",
  stillOpenBody: "لا تزال التوصية مفتوحة. حاول مرة أخرى.",
},
documentSubtype: {
  label: {
    gas_safety: "سلامة الغاز",
    electrical: "الكهرباء",
    fire_safety: "السلامة من الحريق",
    pat_testing: "فحص الأجهزة المحمولة (PAT)",
    lift: "المصعد (LOLER)",
    legionella: "الليجيونيلا",
    pressure_system: "نظام الضغط",
    ppe: "معدات الحماية الشخصية",
    vehicle_roadworthy: "صلاحية السير (MOT)",
    epc: "شهادة أداء الطاقة (EPC)",
    manufacturer: "الشركة المصنّعة",
    extended: "ممتد",
    service_contract: "عقد الخدمة",
    regulatory: "تنظيمي",
    audit: "تدقيق",
    insurance: "التأمين",
    manual: "دليل الاستخدام",
    drawing: "مخطط",
    photo: "صورة",
    report: "تقرير",
  },
  titleExample: {
    gas_safety: "مثال: شهادة سلامة الغاز",
    electrical: "مثال: شهادة التركيبات الكهربائية",
    fire_safety: "مثال: تقييم مخاطر الحريق",
    pat_testing: "مثال: سجل فحص الأجهزة المحمولة",
    lift: "مثال: فحص LOLER الشامل",
    legionella: "مثال: تقييم مخاطر الليجيونيلا",
    pressure_system: "مثال: مخطط الفحص المكتوب",
    ppe: "مثال: سجل فحص معدات الحماية الشخصية",
    vehicle_roadworthy: "مثال: شهادة MOT",
    epc: "مثال: شهادة أداء الطاقة",
    manufacturer: "مثال: ضمان الشركة المصنّعة",
    extended: "مثال: ضمان ممتد",
    service_contract: "مثال: عقد الخدمة السنوي",
    regulatory: "مثال: إشعار امتثال تنظيمي",
    audit: "مثال: تقرير تدقيق الامتثال",
    insurance: "مثال: تأمين المسؤولية العامة",
    manual: "مثال: دليل التشغيل",
    drawing: "مثال: مخطط الطابق",
    photo: "مثال: صورة حالة الأصل",
    report: "مثال: تقرير مسح الحالة",
  },
  titleExampleByType: {
    certificate: "مثال: شهادة سلامة الغاز",
    warranty: "مثال: ضمان الشركة المصنّعة",
    compliance: "مثال: وثيقة التأمين",
    general: "مثال: دليل المعدات",
  },
},
retirePreflight: {
  openInspections_many: "{{count}} فحصًا قيد التنفيذ — أكملها أو تجاهلها أولًا",
  openInspections_few: "{{count}} فحوصات قيد التنفيذ — أكملها أو تجاهلها أولًا",
  openInspections_two: "فحصان قيد التنفيذ — أكملهما أو تجاهلهما أولًا",
  openInspections_zero: "لا فحوصات قيد التنفيذ",
  openJobs_many: "{{count}} عملًا مفتوحًا — أكملها أو ألغها أولًا",
  openJobs_few: "{{count}} أعمال مفتوحة — أكملها أو ألغها أولًا",
  openJobs_two: "عملان مفتوحان — أكملهما أو ألغهما أولًا",
  openJobs_zero: "لا أعمال مفتوحة",
  openCase: "إدخال الأصل إلى الخدمة أو إخراجه منها ما زال جاريًا — أنهِه أو ألغه أولًا",
  openInspections_other: "{{count}} فحص قيد التنفيذ — أكملها أو تجاهلها أولًا",
  openInspections_one: "فحص واحد قيد التنفيذ — أكمله أو تجاهله أولًا",
  openJobs_other: "{{count}} عمل مفتوح — أكملها أو ألغها أولًا",
  openJobs_one: "عمل مفتوح واحد — أكمله أو ألغه أولًا",
},
readinessCard: {
needAttention_zero: "لا شيء يحتاج إلى انتباه",
needAttention_one: "{{count}} يحتاج إلى انتباه",
needAttention_two: "{{count}} يحتاجان إلى انتباه",
needAttention_few: "{{count}} تحتاج إلى انتباه",
needAttention_many: "{{count}} تحتاج إلى انتباه",
needAttention_other: "{{count}} تحتاج إلى انتباه",
foundationsInPlace: "الأساسيات مكتملة",
},
documentTakeOver: {
title: "التصديق نيابةً عنهم؟",
body_zero: "لم يصدّق {{name}} على \"{{title}}\" منذ {{count}} يوم. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
body_one: "لم يصدّق {{name}} على \"{{title}}\" منذ يوم واحد. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
body_two: "لم يصدّق {{name}} على \"{{title}}\" منذ يومين. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
body_few: "لم يصدّق {{name}} على \"{{title}}\" منذ {{count}} أيام. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
body_many: "لم يصدّق {{name}} على \"{{title}}\" منذ {{count}} يومًا. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
body_other: "لم يصدّق {{name}} على \"{{title}}\" منذ {{count}} يوم. هل تريد التصديق عليه بصفتك فريق الأصل؟ سيُسجَّل ذلك على أنه تم نيابةً عنهم.",
keepWaiting: "متابعة الانتظار",
validate: "تصديق",
note_zero: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد {{count}} يوم دون رد.",
note_one: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد يوم واحد دون رد.",
note_two: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد يومين دون رد.",
note_few: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد {{count}} أيام دون رد.",
note_many: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد {{count}} يومًا دون رد.",
note_other: "صدّق عليه فريق الأصل نيابةً عن {{name}} بعد {{count}} يوم دون رد.",
},
lifecycleCopy: {
inspectionDone: "الفحص ✓",
inspectionInProgress: "الفحص قيد التنفيذ",
inspectionNotStarted: "لم يبدأ الفحص",
jobsVerified: "المهام المتحقَّق منها {{verified}}/{{raised}}",
findingsWaived_zero: "لا نتائج متنازل عنها",
findingsWaived_one: "نتيجة واحدة متنازل عنها",
findingsWaived_two: "نتيجتان متنازل عنهما",
findingsWaived_few: "{{count}} نتائج متنازل عنها",
findingsWaived_many: "{{count}} نتيجةً متنازلًا عنها",
findingsWaived_other: "{{count}} نتيجة متنازل عنها",
findingsNeedJob_zero: "لا نتائج تحتاج إلى مهمة",
findingsNeedJob_one: "نتيجة واحدة تحتاج إلى مهمة",
findingsNeedJob_two: "نتيجتان تحتاجان إلى مهمة",
findingsNeedJob_few: "{{count}} نتائج تحتاج إلى مهمة",
findingsNeedJob_many: "{{count}} نتيجةً تحتاج إلى مهمة",
findingsNeedJob_other: "{{count}} نتيجة تحتاج إلى مهمة",
noFindings: "لا توجد نتائج",
retireNoNewWork: "لا يستقبل أي فحوصات أو مهام جديدة إطلاقًا. يبقى السجل والمستندات متاحة للقراءة.",
retireSharesRevoked_zero: "لم تُلغَ أي مشاركة",
retireSharesRevoked_one: "أُلغيت مشاركة واحدة",
retireSharesRevoked_two: "أُلغيت مشاركتان",
retireSharesRevoked_few: "أُلغيت {{count}} مشاركات",
retireSharesRevoked_many: "أُلغيت {{count}} مشاركةً",
retireSharesRevoked_other: "أُلغيت {{count}} مشاركة",
retireIntakeOff: "أُوقف رابط البلاغات العامة",
retireSchedulesCancelled_zero: "لم يُلغَ أي فحص مجدول",
retireSchedulesCancelled_one: "أُلغي فحص مجدول واحد",
retireSchedulesCancelled_two: "أُلغي فحصان مجدولان",
retireSchedulesCancelled_few: "أُلغيت {{count}} فحوصات مجدولة",
retireSchedulesCancelled_many: "أُلغي {{count}} فحصًا مجدولًا",
retireSchedulesCancelled_other: "أُلغي {{count}} فحص مجدول",
retireNoLongerBilled: "لم يعد يُفوتر",
retireHidden: "مخفي من القوائم ومؤشرات الأداء الرئيسية والمخاطر؛ ويُدرج ضمن «خارج الخدمة نهائيًا»",
},
complianceSummary: {
recentInspections_zero: "لم يكتمل أي فحص خلال آخر 30 يومًا",
recentInspections_one: "اكتمل فحص واحد خلال آخر 30 يومًا",
recentInspections_two: "اكتمل فحصان خلال آخر 30 يومًا",
recentInspections_few: "اكتملت {{count}} فحوصات خلال آخر 30 يومًا",
recentInspections_many: "اكتمل {{count}} فحصًا خلال آخر 30 يومًا",
recentInspections_other: "اكتمل {{count}} فحص خلال آخر 30 يومًا",
documentsValid: "جميع مستندات الامتثال المتتبَّعة صالحة حاليًا",
noOverdueSchedules: "لا توجد فحوصات مجدولة متأخرة",
noOpenJobs: "لا توجد مهام مفتوحة مرتبطة بهذا الأصل حاليًا",
uploadDocuments: "حمّل مستندات الامتثال (الشهادات أو الضمانات أو الأدلة) لهذا الأصل",
renewExpired_zero: "جدّد {{count}} مستند امتثال منتهي الصلاحية",
renewExpired_one: "جدّد مستند الامتثال المنتهي الصلاحية",
renewExpired_two: "جدّد مستندَي امتثال منتهيَي الصلاحية",
renewExpired_few: "جدّد {{count}} مستندات امتثال منتهية الصلاحية",
renewExpired_many: "جدّد {{count}} مستندَ امتثال منتهي الصلاحية",
renewExpired_other: "جدّد {{count}} مستند امتثال منتهي الصلاحية",
planRenewals_zero: "خطّط لتجديد {{count}} مستند تنتهي صلاحيته قريبًا",
planRenewals_one: "خطّط لتجديد مستند واحد تنتهي صلاحيته قريبًا",
planRenewals_two: "خطّط لتجديد مستندين تنتهي صلاحيتهما قريبًا",
planRenewals_few: "خطّط لتجديد {{count}} مستندات تنتهي صلاحيتها قريبًا",
planRenewals_many: "خطّط لتجديد {{count}} مستندًا تنتهي صلاحيتها قريبًا",
planRenewals_other: "خطّط لتجديد {{count}} مستند تنتهي صلاحيتها قريبًا",
establishBaseline: "أكمل فحصًا لوضع خط أساس للامتثال يمكن التحقق منه",
scheduleNewInspection_zero: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ {{count}} يوم",
scheduleNewInspection_one: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ يوم واحد",
scheduleNewInspection_two: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ يومين",
scheduleNewInspection_few: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ {{count}} أيام",
scheduleNewInspection_many: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ {{count}} يومًا",
scheduleNewInspection_other: "جدول فحصًا جديدًا — آخر فحص مكتمل كان منذ {{count}} يوم",
completeOverdueSchedules_zero: "أكمل {{count}} فحص مجدول متأخر",
completeOverdueSchedules_one: "أكمل فحصًا مجدولًا متأخرًا واحدًا",
completeOverdueSchedules_two: "أكمل فحصين مجدولين متأخرين",
completeOverdueSchedules_few: "أكمل {{count}} فحوصات مجدولة متأخرة",
completeOverdueSchedules_many: "أكمل {{count}} فحصًا مجدولًا متأخرًا",
completeOverdueSchedules_other: "أكمل {{count}} فحص مجدول متأخر",
resolveOverdueJobs_zero: "عالج أو أعد جدولة {{count}} مهمة مفتوحة متأخرة",
resolveOverdueJobs_one: "عالج أو أعد جدولة مهمة مفتوحة متأخرة واحدة",
resolveOverdueJobs_two: "عالج أو أعد جدولة مهمتين مفتوحتين متأخرتين",
resolveOverdueJobs_few: "عالج أو أعد جدولة {{count}} مهام مفتوحة متأخرة",
resolveOverdueJobs_many: "عالج أو أعد جدولة {{count}} مهمةً مفتوحةً متأخرةً",
resolveOverdueJobs_other: "عالج أو أعد جدولة {{count}} مهمة مفتوحة متأخرة",
reviewUrgentJobs_zero: "راجع {{count}} مهمة مفتوحة عالية الاستعجال وحدّث الحالة أو تواريخ الاستحقاق",
reviewUrgentJobs_one: "راجع مهمة مفتوحة واحدة عالية الاستعجال وحدّث الحالة أو تاريخ الاستحقاق",
reviewUrgentJobs_two: "راجع مهمتين مفتوحتين عاليتَي الاستعجال وحدّث الحالة أو تواريخ الاستحقاق",
reviewUrgentJobs_few: "راجع {{count}} مهام مفتوحة عالية الاستعجال وحدّث الحالة أو تواريخ الاستحقاق",
reviewUrgentJobs_many: "راجع {{count}} مهمةً مفتوحةً عالية الاستعجال وحدّث الحالة أو تواريخ الاستحقاق",
reviewUrgentJobs_other: "راجع {{count}} مهمة مفتوحة عالية الاستعجال وحدّث الحالة أو تواريخ الاستحقاق",
addressFindings_zero: "عالج {{count}} نتيجة غير محلولة من آخر فحص مكتمل",
addressFindings_one: "عالج نتيجة واحدة غير محلولة من آخر فحص مكتمل",
addressFindings_two: "عالج نتيجتين غير محلولتين من آخر فحص مكتمل",
addressFindings_few: "عالج {{count}} نتائج غير محلولة من آخر فحص مكتمل",
addressFindings_many: "عالج {{count}} نتيجةً غير محلولة من آخر فحص مكتمل",
addressFindings_other: "عالج {{count}} نتيجة غير محلولة من آخر فحص مكتمل",
followUpApprovals_zero: "تابع {{count}} موافقة معلّقة",
followUpApprovals_one: "تابع موافقة واحدة معلّقة",
followUpApprovals_two: "تابع موافقتين معلّقتين",
followUpApprovals_few: "تابع {{count}} موافقات معلّقة",
followUpApprovals_many: "تابع {{count}} موافقةً معلّقةً",
followUpApprovals_other: "تابع {{count}} موافقة معلّقة",
},
conditionImpacts: {
expiredDocumentsLabel_zero: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsLabel_one: "مستند امتثال منتهي الصلاحية",
expiredDocumentsLabel_two: "مستندا امتثال منتهيا الصلاحية",
expiredDocumentsLabel_few: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsLabel_many: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsLabel_other: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsInline_zero: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsInline_one: "مستند امتثال منتهي الصلاحية",
expiredDocumentsInline_two: "مستندَي امتثال منتهيَي الصلاحية",
expiredDocumentsInline_few: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsInline_many: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsInline_other: "مستندات امتثال منتهية الصلاحية",
expiredDocumentsRationale_zero: "لا مستندات تجاوزت تاريخ انتهاء صلاحيتها. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiredDocumentsRationale_one: "مستند واحد تجاوز تاريخ انتهاء صلاحيته. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiredDocumentsRationale_two: "مستندان تجاوزا تاريخ انتهاء صلاحيتهما. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiredDocumentsRationale_few: "{{count}} مستندات تجاوزت تاريخ انتهاء صلاحيتها. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiredDocumentsRationale_many: "{{count}} مستندًا تجاوزت تاريخ انتهاء صلاحيتها. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiredDocumentsRationale_other: "{{count}} مستند تجاوزت تاريخ انتهاء صلاحيتها. كل بند منتهي الصلاحية يُنقص الدرجة بما يصل إلى 25 نقطة (بحد أقصى 50 نقطة إجمالًا).",
expiringDocumentsLabel_zero: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsLabel_one: "مستند تنتهي صلاحيته قريبًا",
expiringDocumentsLabel_two: "مستندان تنتهي صلاحيتهما قريبًا",
expiringDocumentsLabel_few: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsLabel_many: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsLabel_other: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsInline_zero: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsInline_one: "مستند تنتهي صلاحيته قريبًا",
expiringDocumentsInline_two: "مستندين تنتهي صلاحيتهما قريبًا",
expiringDocumentsInline_few: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsInline_many: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsInline_other: "مستندات تنتهي صلاحيتها قريبًا",
expiringDocumentsRationale_zero: "لا مستندات ضمن فترة تذكير التجديد قبل انتهاء صلاحيتها (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
expiringDocumentsRationale_one: "مستند واحد ضمن فترة تذكير التجديد قبل انتهاء صلاحيته (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
expiringDocumentsRationale_two: "مستندان ضمن فترة تذكير التجديد قبل انتهاء صلاحيتهما (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
expiringDocumentsRationale_few: "{{count}} مستندات ضمن فترة تذكير التجديد قبل انتهاء صلاحيتها (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
expiringDocumentsRationale_many: "{{count}} مستندًا ضمن فترة تذكير التجديد قبل انتهاء صلاحيتها (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
expiringDocumentsRationale_other: "{{count}} مستند ضمن فترة تذكير التجديد قبل انتهاء صلاحيتها (حتى 8 نقاط لكل مستند، بحد أقصى 24).",
overdueSchedulesLabel_zero: "فحوصات مجدولة متأخرة",
overdueSchedulesLabel_one: "فحص مجدول متأخر",
overdueSchedulesLabel_two: "فحصان مجدولان متأخران",
overdueSchedulesLabel_few: "فحوصات مجدولة متأخرة",
overdueSchedulesLabel_many: "فحوصات مجدولة متأخرة",
overdueSchedulesLabel_other: "فحوصات مجدولة متأخرة",
overdueSchedulesInline_zero: "فحوصات مجدولة متأخرة",
overdueSchedulesInline_one: "فحص مجدول متأخر",
overdueSchedulesInline_two: "فحصين مجدولين متأخرين",
overdueSchedulesInline_few: "فحوصات مجدولة متأخرة",
overdueSchedulesInline_many: "فحوصات مجدولة متأخرة",
overdueSchedulesInline_other: "فحوصات مجدولة متأخرة",
overdueSchedulesRationale_zero: "لا فحوصات مجدولة مُعلَّمة كمتأخرة (12 نقطة لكل فحص، بحد أقصى 24).",
overdueSchedulesRationale_one: "فحص مجدول واحد مُعلَّم كمتأخر (12 نقطة لكل فحص، بحد أقصى 24).",
overdueSchedulesRationale_two: "فحصان مجدولان مُعلَّمان كمتأخرَين (12 نقطة لكل فحص، بحد أقصى 24).",
overdueSchedulesRationale_few: "{{count}} فحوصات مجدولة مُعلَّمة كمتأخرة (12 نقطة لكل فحص، بحد أقصى 24).",
overdueSchedulesRationale_many: "{{count}} فحصًا مجدولًا مُعلَّمًا كمتأخر (12 نقطة لكل فحص، بحد أقصى 24).",
overdueSchedulesRationale_other: "{{count}} فحص مجدول مُعلَّم كمتأخر (12 نقطة لكل فحص، بحد أقصى 24).",
overdueOpenJobsLabel_zero: "مهام مفتوحة متأخرة",
overdueOpenJobsLabel_one: "مهمة مفتوحة متأخرة",
overdueOpenJobsLabel_two: "مهمتان مفتوحتان متأخرتان",
overdueOpenJobsLabel_few: "مهام مفتوحة متأخرة",
overdueOpenJobsLabel_many: "مهام مفتوحة متأخرة",
overdueOpenJobsLabel_other: "مهام مفتوحة متأخرة",
overdueOpenJobsInline_zero: "مهام مفتوحة متأخرة",
overdueOpenJobsInline_one: "مهمة مفتوحة متأخرة",
overdueOpenJobsInline_two: "مهمتين مفتوحتين متأخرتين",
overdueOpenJobsInline_few: "مهام مفتوحة متأخرة",
overdueOpenJobsInline_many: "مهام مفتوحة متأخرة",
overdueOpenJobsInline_other: "مهام مفتوحة متأخرة",
overdueOpenJobsRationale_zero: "لا مهام مفتوحة مضى تاريخ استحقاقها (10 نقاط لكل مهمة، بحد أقصى 30).",
overdueOpenJobsRationale_one: "مهمة مفتوحة واحدة مضى تاريخ استحقاقها (10 نقاط لكل مهمة، بحد أقصى 30).",
overdueOpenJobsRationale_two: "مهمتان مفتوحتان مضى تاريخ استحقاقهما (10 نقاط لكل مهمة، بحد أقصى 30).",
overdueOpenJobsRationale_few: "{{count}} مهام مفتوحة مضى تاريخ استحقاقها (10 نقاط لكل مهمة، بحد أقصى 30).",
overdueOpenJobsRationale_many: "{{count}} مهمةً مفتوحةً مضى تاريخ استحقاقها (10 نقاط لكل مهمة، بحد أقصى 30).",
overdueOpenJobsRationale_other: "{{count}} مهمة مفتوحة مضى تاريخ استحقاقها (10 نقاط لكل مهمة، بحد أقصى 30).",
highUrgencyJobsLabel_zero: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsLabel_one: "مهمة مفتوحة عالية الاستعجال",
highUrgencyJobsLabel_two: "مهمتان مفتوحتان عاليتا الاستعجال",
highUrgencyJobsLabel_few: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsLabel_many: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsLabel_other: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsInline_zero: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsInline_one: "مهمة مفتوحة عالية الاستعجال",
highUrgencyJobsInline_two: "مهمتين مفتوحتين عاليتَي الاستعجال",
highUrgencyJobsInline_few: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsInline_many: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsInline_other: "مهام مفتوحة عالية الاستعجال",
highUrgencyJobsRationale_zero: "لا مهام مفتوحة درجة استعجالها عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
highUrgencyJobsRationale_one: "مهمة مفتوحة واحدة درجة استعجالها عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
highUrgencyJobsRationale_two: "مهمتان مفتوحتان درجة استعجالهما عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
highUrgencyJobsRationale_few: "{{count}} مهام مفتوحة درجة استعجالها عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
highUrgencyJobsRationale_many: "{{count}} مهمةً مفتوحةً درجة استعجالها عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
highUrgencyJobsRationale_other: "{{count}} مهمة مفتوحة درجة استعجالها عالية (8 نقاط لكل مهمة، بحد أقصى 24).",
pendingApprovalsLabel_zero: "تقارير بانتظار الاعتماد",
pendingApprovalsLabel_one: "تقرير بانتظار الاعتماد",
pendingApprovalsLabel_two: "تقريران بانتظار الاعتماد",
pendingApprovalsLabel_few: "تقارير بانتظار الاعتماد",
pendingApprovalsLabel_many: "تقارير بانتظار الاعتماد",
pendingApprovalsLabel_other: "تقارير بانتظار الاعتماد",
pendingApprovalsInline_zero: "تقارير بانتظار الاعتماد",
pendingApprovalsInline_one: "تقرير بانتظار الاعتماد",
pendingApprovalsInline_two: "تقريرين بانتظار الاعتماد",
pendingApprovalsInline_few: "تقارير بانتظار الاعتماد",
pendingApprovalsInline_many: "تقارير بانتظار الاعتماد",
pendingApprovalsInline_other: "تقارير بانتظار الاعتماد",
pendingApprovalsRationale_zero: "لا تقارير مُشارَكة بانتظار اعتماد المستلم (6 نقاط لكل تقرير، بحد أقصى 18).",
pendingApprovalsRationale_one: "تقرير مُشارَك واحد لم يعتمده المستلم بعد (6 نقاط لكل تقرير، بحد أقصى 18).",
pendingApprovalsRationale_two: "تقريران مُشارَكان لم يعتمدهما المستلم بعد (6 نقاط لكل تقرير، بحد أقصى 18).",
pendingApprovalsRationale_few: "{{count}} تقارير مُشارَكة لم يعتمدها المستلم بعد (6 نقاط لكل تقرير، بحد أقصى 18).",
pendingApprovalsRationale_many: "{{count}} تقريرًا مُشارَكًا لم يعتمدها المستلم بعد (6 نقاط لكل تقرير، بحد أقصى 18).",
pendingApprovalsRationale_other: "{{count}} تقرير مُشارَك لم يعتمدها المستلم بعد (6 نقاط لكل تقرير، بحد أقصى 18).",
recurringIssuesLabel_zero: "أعطال متكررة",
recurringIssuesLabel_one: "عطل متكرر",
recurringIssuesLabel_two: "عطلان متكرران",
recurringIssuesLabel_few: "أعطال متكررة",
recurringIssuesLabel_many: "أعطال متكررة",
recurringIssuesLabel_other: "أعطال متكررة",
recurringIssuesInline_zero: "أعطال متكررة",
recurringIssuesInline_one: "عطل متكرر",
recurringIssuesInline_two: "عطلين متكررين",
recurringIssuesInline_few: "أعطال متكررة",
recurringIssuesInline_many: "أعطال متكررة",
recurringIssuesInline_other: "أعطال متكررة",
recurringIssuesRationale_zero: "لا أعطال ظهرت في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
recurringIssuesRationale_one: "عطل واحد ظهر في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
recurringIssuesRationale_two: "عطلان ظهرا في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
recurringIssuesRationale_few: "{{count}} أعطال ظهرت في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
recurringIssuesRationale_many: "{{count}} عطلًا ظهرت في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
recurringIssuesRationale_other: "{{count}} عطل ظهرت في أكثر من فحص ضمن الفحوصات الـ{{window}} الأخيرة — الإصلاح السابق لا يصمد (6 نقاط لكل عطل، بحد أقصى 18).",
inspectionFindingsLabel_zero: "نتائج فحص غير محلولة",
inspectionFindingsLabel_one: "نتيجة فحص غير محلولة",
inspectionFindingsLabel_two: "نتيجتا فحص غير محلولتين",
inspectionFindingsLabel_few: "نتائج فحص غير محلولة",
inspectionFindingsLabel_many: "نتائج فحص غير محلولة",
inspectionFindingsLabel_other: "نتائج فحص غير محلولة",
inspectionFindingsInline_zero: "نتائج فحص غير محلولة",
inspectionFindingsInline_one: "نتيجة فحص غير محلولة",
inspectionFindingsInline_two: "نتيجتَي فحص غير محلولتين",
inspectionFindingsInline_few: "نتائج فحص غير محلولة",
inspectionFindingsInline_many: "نتائج فحص غير محلولة",
inspectionFindingsInline_other: "نتائج فحص غير محلولة",
inspectionFindingsRationale_zero: "آخر فحص مكتمل ليس فيه أي بند فاشل أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
inspectionFindingsRationale_one: "آخر فحص مكتمل فيه بند واحد فاشل أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
inspectionFindingsRationale_two: "آخر فحص مكتمل فيه بندان فاشلان أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
inspectionFindingsRationale_few: "آخر فحص مكتمل فيه {{count}} بنود فاشلة أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
inspectionFindingsRationale_many: "آخر فحص مكتمل فيه {{count}} بندًا فاشلًا أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
inspectionFindingsRationale_other: "آخر فحص مكتمل فيه {{count}} بند فاشل أو بحاجة إلى إصلاح (4 نقاط لكل بند، بحد أقصى 20).",
noDocumentsLabel: "لا توجد مستندات محفوظة",
noDocumentsInline: "عدم وجود مستندات محفوظة",
noDocumentsRationale: "لا توجد شهادات أو ضمانات أو ملفات امتثال مرتبطة بهذا الأصل. يتوقع المدققون عادةً وجود أدلة محفوظة.",
noCompletedInspectionLabel: "لا يوجد خط أساس من فحص مكتمل",
noCompletedInspectionInline: "عدم وجود خط أساس من فحص مكتمل",
noCompletedInspectionRationale: "لا يوجد فحص مكتمل أو موافَق عليه بعد، لذا لا يمكن التحقق من الامتثال من البيانات الميدانية.",
staleInspectionLabel: "آخر فحص منذ أكثر من 90 يومًا",
staleInspectionInline: "مرور أكثر من 90 يومًا على آخر فحص",
staleInspectionRationale_zero: "آخر فحص مكتمل كان اليوم. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
staleInspectionRationale_one: "آخر فحص مكتمل كان منذ يوم واحد. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
staleInspectionRationale_two: "آخر فحص مكتمل كان منذ يومين. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
staleInspectionRationale_few: "آخر فحص مكتمل كان منذ {{count}} أيام. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
staleInspectionRationale_many: "آخر فحص مكتمل كان منذ {{count}} يومًا. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
staleInspectionRationale_other: "آخر فحص مكتمل كان منذ {{count}} يوم. الأدلة الأقدم تزيد من عدم اليقين عند التدقيق.",
recentInspectionsLabel: "نشاط فحص حديث",
recentInspectionsInline: "نشاط الفحص الحديث",
recentInspectionsRationale_zero: "لم يكتمل أي فحص خلال آخر 30 يومًا، ولا توجد فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
recentInspectionsRationale_one: "اكتمل فحص واحد خلال آخر 30 يومًا دون أي فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
recentInspectionsRationale_two: "اكتمل فحصان خلال آخر 30 يومًا دون أي فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
recentInspectionsRationale_few: "اكتملت {{count}} فحوصات خلال آخر 30 يومًا دون أي فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
recentInspectionsRationale_many: "اكتمل {{count}} فحصًا خلال آخر 30 يومًا دون أي فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
recentInspectionsRationale_other: "اكتمل {{count}} فحص خلال آخر 30 يومًا دون أي فحوصات مجدولة أو مهام متأخرة — إشارة إيجابية.",
cleanWorkQueueLabel: "لا أعمال مفتوحة من آخر فحص",
cleanWorkQueueInline: "عدم وجود أعمال مفتوحة من آخر فحص",
cleanWorkQueueRationale: "لا توجد مهام مفتوحة ولا نتائج غير محلولة في آخر فحص مكتمل.",
},
model: {
placeTypeLabel: "نوع المكان",
placeTypeHint: "مبنى أو طابق أو غرفة أو أي منطقة أخرى. تظهر هنا أيضًا أنواع الأماكن الخاصة بك.",
customTypeLabel: "نوع الأصل",
customTypeNone: "لا شيء",
vehicleNoParent: "المركبة لا توجد داخل أصل آخر، بل لها موقع أساسي بدلًا من ذلك.",
sitsInLabel: "يوجد في",
sitsInHint: "المكان أو المركبة أو العنصر الذي يوجد فيه.",
sitsInHintPlace: "المكان الذي يتبعه هذا المكان، مثل الطابق الذي تقع فيه الغرفة.",
sitsInA11yChange: "يوجد في {{name}}. تغيير",
sitsInA11yPick: "اختر مكان وجوده",
sitsInNone: "ليس داخل أي شيء",
sitsInClear: "إخراج",
sitsInPickerTitle: "أين يوجد؟",
sitsInSearch: "ابحث في الأماكن والأصول",
fieldsLabel: "تفاصيل {{type}}",
yes: "نعم",
no: "لا",
datePlaceholder: "YYYY-MM-DD",
fieldError: {
required: "املأ هذا الحقل",
number: "أدخل رقمًا",
date: "أدخل التاريخ بصيغة YYYY-MM-DD",
choice: "اختر أحد الخيارات",
},
fieldsIncompleteTitle: "بعض التفاصيل ناقصة",
fieldsIncompleteBody: "املأ التفاصيل المميزة ثم احفظ مرة أخرى.",
placementFailedTitle: "تعذّر النقل",
placementFailedBody: "تم حفظ الأصل، لكن مكانه لم يتغير. حاول مرة أخرى من صفحة الأصل.",
placementError: {
vehicle: "المركبة لا توجد داخل أصل آخر، بل لها موقع أساسي بدلًا من ذلك.",
placeInPlace: "لا يمكن أن يوجد المكان إلا داخل مكان آخر.",
alreadyPlaced: "هذا الأصل موجود بالفعل في مكان آخر. انقله بدلًا من ذلك.",
},
zonesLabel: "المناطق",
zonesHint: "مجموعات تمتد عبر الأماكن، مثل منطقة حريق أو منطقة تنظيف. افصل بينها بفواصل. يمكن لقواعد المجموعات والجولات الاختيار حسب المنطقة.",
zonesPlaceholder: "منطقة الحريق 2، الجناح الشمالي",
placeTypes: {
property: "عقار",
building: "مبنى",
wing: "جناح",
floor: "طابق",
room: "غرفة",
unit: "وحدة",
ward: "جناح مرضى",
data_hall: "قاعة بيانات",
rack: "خزانة خوادم",
plant_room: "غرفة معدات",
car_park: "موقف سيارات",
yard: "ساحة",
grounds: "أراضٍ",
pool: "مسبح",
gate: "بوابة",
area: "منطقة",
},
card: {
title: "أين يوجد",
homeTitle: "الموقع الأساسي",
noHomeSite: "لا يوجد موقع أساسي بعد",
notInside: "ليس داخل مكان آخر",
twoParents: "هذا موجود في مكانين: {{names}}. احتفظ بواحد.",
keepParent: "الاحتفاظ بـ {{name}}",
contains_zero: "لا يحتوي على عناصر",
contains_one: "يحتوي على عنصر واحد",
contains_two: "يحتوي على عنصرين",
contains_few: "يحتوي على {{count}} عناصر",
contains_many: "يحتوي على {{count}} عنصرًا",
contains_other: "يحتوي على {{count}} عنصر",
directlyInside_zero: "بداخله مباشرة ({{count}})",
directlyInside_one: "بداخله مباشرة ({{count}})",
directlyInside_two: "بداخله مباشرة ({{count}})",
directlyInside_few: "بداخله مباشرة ({{count}})",
directlyInside_many: "بداخله مباشرة ({{count}})",
directlyInside_other: "بداخله مباشرة ({{count}})",
andMore_zero: "ولا مزيد",
andMore_one: "وعنصر آخر",
andMore_two: "وعنصران آخران",
andMore_few: "و{{count}} عناصر أخرى",
andMore_many: "و{{count}} عنصرًا آخر",
andMore_other: "و{{count}} عنصر آخر",
addPlace: "إضافة مكان بداخله",
addEquipment: "إضافة معدّات هنا",
move: "نقل",
putInside: "وضع داخل",
takeOut: "إخراج",
placeReport: "\u062a\u0642\u0631\u064a\u0631 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0643\u0627\u0646",
zones: "المناطق",
rollupPlaces_zero: "لا أماكن",
rollupPlaces_one: "مكان واحد",
rollupPlaces_two: "مكانان",
rollupPlaces_few: "{{count}} أماكن",
rollupPlaces_many: "{{count}} مكانًا",
rollupPlaces_other: "{{count}} مكان",
rollupEquipment_zero: "لا معدّات",
rollupEquipment_one: "معدّة واحدة",
rollupEquipment_two: "معدّتان",
rollupEquipment_few: "{{count}} معدّات",
rollupEquipment_many: "{{count}} معدّة",
rollupEquipment_other: "{{count}} معدّة",
rollupVehicles_zero: "لا مركبات",
rollupVehicles_one: "مركبة واحدة",
rollupVehicles_two: "مركبتان",
rollupVehicles_few: "{{count}} مركبات",
rollupVehicles_many: "{{count}} مركبة",
rollupVehicles_other: "{{count}} مركبة",
rollupOther_zero: "لا شيء آخر",
rollupOther_one: "عنصر آخر",
rollupOther_two: "عنصران آخران",
rollupOther_few: "{{count}} عناصر أخرى",
rollupOther_many: "{{count}} عنصرًا آخر",
rollupOther_other: "{{count}} عنصر آخر",
rollupAtRisk_zero: "لا شيء بخطر مرتفع",
rollupAtRisk_one: "واحد بخطر مرتفع",
rollupAtRisk_two: "اثنان بخطر مرتفع",
rollupAtRisk_few: "{{count}} بخطر مرتفع",
rollupAtRisk_many: "{{count}} بخطر مرتفع",
rollupAtRisk_other: "{{count}} بخطر مرتفع",
rollupDueVisits_zero: "لا زيارات مستحقة",
rollupDueVisits_one: "زيارة مستحقة",
rollupDueVisits_two: "زيارتان مستحقتان",
rollupDueVisits_few: "{{count}} زيارات مستحقة",
rollupDueVisits_many: "{{count}} زيارة مستحقة",
rollupDueVisits_other: "{{count}} زيارة مستحقة",
rollupOpenJobs_zero: "لا أعمال مفتوحة",
rollupOpenJobs_one: "عمل مفتوح",
rollupOpenJobs_two: "عملان مفتوحان",
rollupOpenJobs_few: "{{count}} أعمال مفتوحة",
rollupOpenJobs_many: "{{count}} عملًا مفتوحًا",
rollupOpenJobs_other: "{{count}} عمل مفتوح",
rollupSeeWork: "عرض كل الأعمال في الداخل",
addMany: "إضافة عدة عناصر في الداخل",
startRound: "بدء جولة",
groupRule: "إضافة قاعدة مجموعة",
},
},
bulk: {
buildingTitle: "إعداد مبنى",
seriesTitle: "إضافة عدة عناصر دفعة واحدة",
buildingAction: "إعداد مبنى",
buildingActionA11y: "إعداد مبنى في {{site}}",
buildingIntro: "اختر نوع المبنى وحجمه. سترى كل مكان، وما يضيفه إلى فاتورتك، قبل إنشاء أي شيء.",
seriesIntro: "أضف سلسلة مرقّمة من الأماكن أو العناصر داخل {{place}}.",
presetLabel: "نوع المبنى",
multiUseHint: "موقع متعدد الاستخدامات؟ أعِدّ كل مبنى وحده، ولكلٍّ نوعه.",
siteLabel: "الموقع",
siteSearch: "البحث في المواقع",
noSite: "اختر موقعًا",
buildingNameLabel: "اسم المبنى",
buildingNamePlaceholder: "المبنى A",
buildingNameRequired: "أعطِ المبنى اسمًا",
defaultBuildingName: "المبنى الرئيسي",
floorsLabel: "الطوابق",
firstFloorLabel: "تبدأ الطوابق من",
spaceLabel: "في كل طابق",
perFloorLabel: "عدد {{type}} في كل طابق",
perSpaceLabel: "عدد {{inside}} في كل {{type}}",
extrasLabel: "أضف أيضًا",
sitePlacesLabel: "أماكن مشتركة في الموقع",
sitePlacesHint: "تكون هذه على مستوى الموقع، لا داخل المبنى. لا يظهر إلا ما ليس في الموقع بعد.",
addTypesLabel: "إضافة أنواع الأصول المعتادة",
addTypesHint: "يضيف {{types}} مع تفاصيلها، إن لم تكن لديك بعد.",
seriesKindLabel: "ماذا تضيف",
patternLabel: "نمط الاسم",
patternHint: "استخدم # للرقم. ## يكمل إلى رقمين، فيعطي «غرفة ##» غرفة 01، غرفة 02.",
defaultItemPattern: "عنصر ##",
startLabel: "البدء من",
countLabel: "كم عددها",
previewTitle: "ما سيتم إنشاؤه",
quoteTitle_zero: "لا أصول جديدة",
quoteTitle_one: "أصل جديد واحد",
quoteTitle_two: "أصلان جديدان",
quoteTitle_few: "{{count}} أصول جديدة",
quoteTitle_many: "{{count}} أصلًا جديدًا",
quoteTitle_other: "{{count}} أصل جديد",
quoteBilled: "كل مكان وكل عنصر أصل محتسب في الفاتورة.",
quoteNow_zero: "ليس لديك أي أصل الآن.",
quoteNow_one: "لديك الآن أصل واحد.",
quoteNow_two: "لديك الآن أصلان.",
quoteNow_few: "لديك الآن {{count}} أصول.",
quoteNow_many: "لديك الآن {{count}} أصلًا.",
quoteNow_other: "لديك الآن {{count}} أصل.",
quoteAfter: "سيصبح لديك {{after}} أصل.",
quoteAfterLimit: "سيصبح لديك {{after}} من أصل {{limit}} تسمح بها خطتك.",
quotePrice: "ترتفع تكلفتك الشهرية من {{before}} إلى {{after}}.",
quoteOverLimit: "هذا أكثر مما تسمح به خطتك ({{limit}} أصل). غيّر خطتك أولًا، أو أنشئ عددًا أقل.",
quoteNeedsPlan: "اختر خطة قبل إضافة مزيد من الأصول.",
tooMany: "{{max}} على الأكثر في المرة الواحدة. أنشئ عددًا أقل، أو قسّمها على دفعات.",
createButton_zero: "إنشاء",
createButton_one: "إنشاء أصل واحد",
createButton_two: "إنشاء أصلين",
createButton_few: "إنشاء {{count}} أصول",
createButton_many: "إنشاء {{count}} أصلًا",
createButton_other: "إنشاء {{count}} أصل",
created_zero: "لم يُنشأ شيء",
created_one: "تم إنشاء أصل واحد",
created_two: "تم إنشاء أصلين",
created_few: "تم إنشاء {{count}} أصول",
created_many: "تم إنشاء {{count}} أصلًا",
created_other: "تم إنشاء {{count}} أصل",
failedTitle: "تعذّر الإنشاء",
failedBody: "لم يُنشأ شيء. تحقّق من الاتصال وحاول مرة أخرى.",
names: {
groundFloor: "الطابق الأرضي",
floor: "الطابق {{n}}",
space: {
room: "غرفة {{code}}",
ward: "جناح {{code}}",
data_hall: "قاعة البيانات {{n}}",
gate: "بوابة {{code}}",
unit: "وحدة {{code}}",
area: "منطقة {{code}}",
},
inside: {
room: "غرفة {{parent}}-{{n}}",
rack: "خزانة {{parent}}-{{n}}",
},
},
},
presets: {
names: {
office_block: "مبنى مكاتب",
hotel: "فندق",
hospital: "مستشفى",
data_centre: "مركز بيانات",
airport: "مطار",
shopping_centre: "مركز تسوق",
school: "مدرسة",
warehouse: "مستودع",
custom: "شيء آخر",
},
descriptions: {
office_block: "طوابق مكاتب، مع استقبال وغرفة معدّات.",
hotel: "غرف نزلاء في كل طابق، واستقبال ومطعم وصالة رياضية ومسابح وغرفة معدّات.",
hospital: "أجنحة في كل طابق بداخلها غرف، واستقبال وغرفة معدّات.",
data_centre: "قاعات بيانات بداخلها خزائن، وغرف معدّات وساحة وبوابة.",
airport: "بوابات في كل طابق، وتسجيل الوصول وصالة أمتعة وموقف سيارات.",
shopping_centre: "وحدات تجارية في كل طابق، وساحة مطاعم وموقف سيارات.",
school: "فصول دراسية في كل طابق، وقاعة وأرض وموقف سيارات.",
warehouse: "مناطق تخزين ومكتب وساحة وبوابة.",
custom: "طوابق وغرف فقط. أضف أنواع أماكنك الخاصة لاحقًا.",
},
extras: {
reception: "الاستقبال",
restaurant: "مطعم",
gym: "صالة رياضية",
pool: "مسبح",
plant_room: "غرفة المعدّات",
check_in: "تسجيل الوصول",
baggage_hall: "صالة الأمتعة",
food_court: "ساحة المطاعم",
hall: "قاعة",
office: "مكتب",
car_park: "موقف سيارات",
grounds: "الأرض المحيطة",
yard: "ساحة",
gate: "بوابة",
},
types: {
guest_room: "غرفة نزلاء",
fire_door: "باب حريق",
lift: "مصعد",
escalator: "سلم متحرك",
air_handler: "وحدة مناولة الهواء",
chiller: "مبرّد",
boiler: "غلاية",
generator: "مولّد",
ups: "UPS",
crac_unit: "وحدة تكييف دقيق",
pdu: "PDU",
infusion_pump: "مضخة تسريب",
medical_gas_outlet: "مخرج غاز طبي",
baggage_belt: "سير الأمتعة",
jet_bridge: "جسر الصعود",
dock_door: "باب رصيف التحميل",
racking: "رفوف",
},
fields: {
beds: "الأسرّة",
accessible: "مهيّأ لذوي الإعاقة",
fireRating: "مقاومة الحريق",
selfClosing: "إغلاق ذاتي",
capacityKg: "الحمولة (كغ)",
floorsServed: "الطوابق المخدومة",
riseM: "الارتفاع (م)",
airflow: "تدفق الهواء (م³/ث)",
filterSize: "مقاس الفلتر",
refrigerant: "غاز التبريد",
capacityKw: "القدرة (كيلوواط)",
fuel: "الوقود",
outputKw: "القدرة الخارجة (كيلوواط)",
ratingKva: "القدرة الاسمية (kVA)",
batteryDate: "تاريخ تركيب البطارية",
ratingA: "التيار الاسمي (أمبير)",
phase: "الطور",
serialNumber: "الرقم التسلسلي",
nextCalibration: "المعايرة التالية",
gas: "الغاز",
lengthM: "الطول (م)",
leveller: "مسوّي الرصيف",
bays: "الحجرات",
loadRatingKg: "الحمل المسموح (كغ)",
},
},
  valueLife: {
    title: "القيمة والعمر (اختياري)",
    hint: "يستخدمه Asset 360 لعرض عمر الأصل وقيمته وكلفة الإصلاحات مقارنة بالاستبدال.",
    installedOn: "تاريخ التركيب",
    installedOnPlaceholder: "YYYY-MM-DD",
    expectedLife: "العمر المتوقع بالسنوات",
    expectedLifePlaceholder: "مثلًا 15",
    purchaseCost: "كلفة الشراء",
    replacementCost: "كلفة الاستبدال",
    replacementCostHelper: "ما سيكلفه استبداله اليوم.",
    currency: "العملة",
    currencyPlaceholder: "مثلًا SAR",
    invalidTitle: "تحقق من القيمة والعمر",
    invalidBody: "بعض بيانات القيمة والعمر غير صالحة. صحح الحقول المحددة أو امسحها.",
    saveFailedTitle: "لم تُحفظ القيمة والعمر",
    saveFailedBody: "حُفظ باقي الأصل. حاول حفظ القيمة والعمر مرة أخرى.",
    error: {
      installedOn: "استخدم تاريخًا مثل 2019-06-30.",
      expectedLifeYears: "أدخل عدد سنوات صحيحًا من 1 إلى 200.",
      purchaseCost: "أدخل مبلغًا مثل 1250 أو 1250.50.",
      replacementCost: "أدخل مبلغًا مثل 1250 أو 1250.50.",
      currency: "استخدم رمزًا من ثلاثة أحرف مثل SAR.",
    },
  },
  report360Charts: {
    other: "أخرى",
    dataQualityA11y: "جودة البيانات {{score}} من 100، {{band}}",
    measureA11y: "{{label}}: {{score}} من 100",
    notAvailable: "غير متاح",
    trendEmptyA11y: "{{label}}: لا توجد أرقام محفوظة بعد.",
    trendEmpty: "لا توجد أرقام يومية محفوظة بعد. تتراكم ليلة بعد ليلة.",
  },
  report360,
};
